/* tslint:disable */
/* eslint-disable */
/**
 * FlowRithm API
 * FlowRithm Trading Platform API - User Service
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from './configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common';
import type { RequestArgs } from './base';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, BaseAPI, RequiredError, operationServerMap } from './base';

export interface AddSupportedBrokerRequest {
    'broker_type': string;
    'display_name': string;
    'auth_method': string;
    'description'?: string;
    'website_url'?: string;
    'logo_url'?: string;
    'is_active'?: boolean;
    'is_beta'?: boolean;
}
export interface AddWatchlistItem201Response {
    'success'?: boolean;
    'data'?: WatchlistItemResponse;
    'message'?: string;
}
/**
 * Request schema for adding an instrument to watchlist.
 */
export interface AddWatchlistItemRequest {
    /**
     * Instrument UUID
     */
    'instrument_id': string;
    /**
     * Display order within group
     */
    'display_order'?: number;
}
/**
 * Streaming response wrapper
 */
export interface AiAssistAguiStream200Response {
    /**
     * Streaming response data
     */
    'data'?: string;
}
export interface AiAssistAguiStreamRequest {
    [key: string]: any;

    /**
     * FlowRithm conversation thread ID
     */
    'threadId': string;
    /**
     * Unique run identifier
     */
    'runId': string;
    /**
     * Array of AG-UI Message objects
     */
    'messages': Array<{ [key: string]: any; }>;
    /**
     * Available tools (optional)
     */
    'tools'?: Array<{ [key: string]: any; }>;
    /**
     * UI context information (optional)
     */
    'context'?: Array<{ [key: string]: any; }>;
    /**
     * AG-UI state object (optional)
     */
    'state'?: { [key: string]: any; };
}
export interface AiAssistSessionDelete200Response {
    /**
     * Success message
     */
    'message'?: string;
    /**
     * Deleted session ID
     */
    'session_id'?: string;
}
export interface AiAssistSessionUpdate200Response {
    /**
     * Success message
     */
    'message'?: string;
    /**
     * Updated session ID
     */
    'session_id'?: string;
}
export interface BrokerAccountDisconnect200Response {
    'status': string;
}
export interface BrokerAccountDisconnectRequest {
    /**
     * Registration or connection identifier
     */
    'registration_id': string;
}
/**
 * Paged broker account list.
 */
export interface BrokerAccountListResponse {
    [key: string]: any;

    'accounts'?: Array<BrokerAccountResponse>;
    'total'?: number;
    'limit'?: number;
    'offset'?: number;
}
/**
 * Broker account metadata.
 */
export interface BrokerAccountResponse {
    [key: string]: any;

    'account_id': string;
    'broker_type': string;
    'account_name'?: string;
    'status': string;
    'auto_sync_enabled'?: boolean;
    'real_time_data_enabled'?: boolean;
    'created_at'?: string;
    'updated_at'?: string;
}
export interface BrokerAccountUpdateRequest {
    'account_name'?: string;
    'auto_sync_enabled'?: boolean;
    'real_time_data_enabled'?: boolean;
}
/**
 * Broker platform metadata.
 */
export interface BrokerMetadataResponse {
    /**
     * Broker identifier
     */
    'id': string;
    /**
     * Broker type (zerodha, dhan, upstox, etc.)
     */
    'broker_type': string;
    /**
     * Human-readable broker name
     */
    'display_name': string;
    /**
     * Broker description
     */
    'description'?: string;
    /**
     * Broker website URL
     */
    'website_url'?: string;
    /**
     * Broker logo URL
     */
    'logo_url'?: string;
    /**
     * Authentication method (OAUTH2, OAUTH2_CUSTOM, API_KEY, etc.)
     */
    'auth_method': string;
    /**
     * Whether broker supports paper trading
     */
    'supports_paper_trading': boolean;
    /**
     * Whether broker supports real-time market data
     */
    'supports_real_time_data': boolean;
    /**
     * List of supported markets (NSE, BSE, MCX, etc.)
     */
    'supported_markets'?: Array<string>;
    /**
     * List of supported segments (equity, derivatives, commodities, etc.)
     */
    'supported_segments'?: Array<string>;
    /**
     * Whether broker is currently active
     */
    'is_active': boolean;
    /**
     * Whether broker is in beta status
     */
    'is_beta': boolean;
}
export interface BrokerRegistrationDeregister200Response {
    /**
     * Whether deregistration was successful
     */
    'success': boolean;
    /**
     * Registration ID
     */
    'id': string;
    /**
     * Status message
     */
    'message': string;
}
export interface BrokerRegistrationMigrateToTOTPRequest {
    /**
     * Broker password (for Zerodha) or TOTP token (for Groww)
     */
    'password': string;
    /**
     * Base32-encoded TOTP secret
     */
    'totp_secret': string;
}
export interface BrokerRegistrationReconnectRequest {
    /**
     * Account registration ID
     */
    'registration_id': string;
    /**
     * Force refresh even if already connected
     */
    'force_refresh'?: boolean;
}
export interface BrokerRegistrationRequest {
    /**
     * Broker platform (zerodha, dhan, upstox)
     */
    'broker_type': string;
    /**
     * User-defined account name
     */
    'account_name': string;
    /**
     * Broker\'s account identifier (e.g., Zerodha client ID)
     */
    'account_id': string;
    'paper_trading'?: boolean;
    'real_time_data_enabled'?: boolean;
    'auto_sync_enabled'?: boolean;
    /**
     * Kite Connect API key (required for Zerodha). Create app at kite.zerodha.com
     */
    'api_key'?: string;
    /**
     * Kite Connect API secret (required for Zerodha)
     */
    'api_secret'?: string;
}
/**
 * Broker registration initiation payload.
 */
export interface BrokerRegistrationResponse {
    [key: string]: any;

    'registration_id'?: string;
    /**
     * OAuth authorization URL to redirect user to broker
     */
    'oauth_url'?: string;
    /**
     * Whether reusing an existing pending registration
     */
    'is_reusing_existing'?: boolean;
    /**
     * Account registration status
     */
    'account_status'?: string;
}
export interface BrokerRegistrationTOTPRequest {
    /**
     * Broker platform (e.g., zerodha, groww). Must support automated login.
     */
    'broker_type': string;
    /**
     * User-defined account name
     */
    'account_name': string;
    /**
     * Broker account ID - maps to broker_account_id in DB (e.g., AB1234 for Zerodha, email for Groww)
     */
    'account_id': string;
    /**
     * Broker password (for Zerodha) or TOTP token (for Groww)
     */
    'password': string;
    /**
     * Base32-encoded TOTP secret
     */
    'totp_secret': string;
    /**
     * Enable paper trading mode
     */
    'paper_trading'?: boolean;
    /**
     * Enable real-time data
     */
    'real_time_data_enabled'?: boolean;
    /**
     * Enable auto-sync
     */
    'auto_sync_enabled'?: boolean;
    /**
     * Kite Connect API key (required for Zerodha). Create app at kite.zerodha.com
     */
    'api_key'?: string;
    /**
     * Kite Connect API secret (required for Zerodha)
     */
    'api_secret'?: string;
}
export interface BrokerRegistrationUpdateTOTPCredentialsRequest {
    /**
     * New broker password (for Zerodha) or TOTP token (for Groww)
     */
    'password': string;
    /**
     * New base32-encoded TOTP secret
     */
    'totp_secret': string;
}
/**
 * Broker token lookup result (symbol + broker → token).
 */
export interface BrokerTokenResponse {
    /**
     * Trading symbol
     */
    'symbol': string;
    /**
     * Exchange code
     */
    'exchange': string;
    /**
     * Broker type
     */
    'broker_type': string;
    /**
     * Broker-specific instrument token
     */
    'broker_instrument_token': string;
    /**
     * Broker-specific symbol
     */
    'broker_symbol'?: string;
    /**
     * Broker-specific exchange
     */
    'broker_exchange'?: string;
    /**
     * Platform instrument identifier
     */
    'instrument_id': string;
    /**
     * Whether the broker mapping is verified
     */
    'is_verified': boolean;
}
export interface ChangeUserRole403Response {
    'detail'?: string;
}
export interface ChangeUserRoleRequest {
    /**
     * New role to assign
     */
    'role': ChangeUserRoleRequestRoleEnum;
}

export const ChangeUserRoleRequestRoleEnum = {
    User: 'user',
    Admin: 'admin'
} as const;

export type ChangeUserRoleRequestRoleEnum = typeof ChangeUserRoleRequestRoleEnum[keyof typeof ChangeUserRoleRequestRoleEnum];

export interface CheckUserQuota200Response {
    'success'?: boolean;
    'data'?: CheckUserQuota200ResponseData;
}
export interface CheckUserQuota200ResponseData {
    'can_create'?: boolean;
    'current'?: number;
    'limit'?: number;
    'remaining'?: number;
}
export interface CheckUserQuota403Response {
    'success'?: boolean;
    'error'?: string;
    'message'?: string;
    'data'?: object;
}
/**
 * Broker connection status.
 */
export interface ConnectionStatusResponse {
    [key: string]: any;

    'is_connected'?: boolean;
    'status'?: string;
}
/**
 * Response schema for ADK session creation.
 */
export interface CreateSessionResponse {
    /**
     * ADK session_id (simple string ID, e.g., \'123456789\' or \'custom-session-123\')
     */
    'session_id': string;
    /**
     * Session creation timestamp in ISO 8601 format
     */
    'created_at': string;
}
export interface CreateUser201Response {
    'success'?: boolean;
    'data'?: object;
    'message'?: string;
}
export interface CreateUserCategory201Response {
    'success'?: boolean;
    'data'?: GetUserCategories200ResponseDataInner;
    'message'?: string;
}
export interface CreateUserCategoryRequest {
    'name': string;
    'description'?: string;
    'is_active'?: boolean;
}
export interface CreateUserRequest {
    'email': string;
    'first_name'?: string;
    'last_name'?: string;
    'username'?: string;
    'category_id'?: string;
    'currency_preference'?: string;
    'billing_address'?: object;
    'tax_id'?: string;
}
export interface CreateWatchlistGroup201Response {
    'success'?: boolean;
    'data'?: WatchlistGroupResponse;
    'message'?: string;
}
/**
 * Request schema for creating a watchlist group.
 */
export interface CreateWatchlistGroupRequest {
    /**
     * Group name
     */
    'name': string;
    /**
     * Display order (lower numbers appear first)
     */
    'display_order'?: number;
    /**
     * Whether this is the default group
     */
    'is_default'?: boolean;
}
export interface DeleteWatchlistGroup200Response {
    'success'?: boolean;
    'message'?: string;
}
export interface DetailedHealthCheck200Response {
    'status'?: string;
    'service'?: string;
    'version'?: string;
    'timestamp'?: string;
    'dependencies'?: object;
}
/**
 * Standard error envelope used across FlowRithm APIs.
 */
export interface ErrorResponse {
    [key: string]: any;

    'error'?: string;
    'message'?: string;
    'details'?: { [key: string]: any; };
}
export interface GetAllWatchlistGroups200Response {
    'success'?: boolean;
    'data'?: GetAllWatchlistGroups200ResponseData;
}
export interface GetAllWatchlistGroups200ResponseData {
    'groups'?: Array<WatchlistGroupResponse>;
}
export interface GetAllWatchlistItems200Response {
    'success'?: boolean;
    'data'?: GetAllWatchlistItems200ResponseData;
}
export interface GetAllWatchlistItems200ResponseData {
    'items'?: Array<WatchlistItemResponse>;
}
export interface GetCurrentUser200Response {
    'success'?: boolean;
    'data'?: GetCurrentUser200ResponseData;
}
export interface GetCurrentUser200ResponseData {
    'id'?: string;
    'firebase_uid'?: string;
    'email'?: string;
    'email_verified'?: boolean;
    'username'?: string;
    'first_name'?: string;
    'last_name'?: string;
    'status'?: string;
    'is_active'?: boolean;
    'category_id'?: string;
    'currency_preference'?: string;
    'strategies_count'?: number;
    'screeners_count'?: number;
    /**
     * User role. Values: \'user\' or \'admin\'
     */
    'role'?: GetCurrentUser200ResponseDataRoleEnum;
    'last_login'?: string;
    'created_at'?: string;
    'updated_at'?: string;
}

export const GetCurrentUser200ResponseDataRoleEnum = {
    User: 'user',
    Admin: 'admin'
} as const;

export type GetCurrentUser200ResponseDataRoleEnum = typeof GetCurrentUser200ResponseDataRoleEnum[keyof typeof GetCurrentUser200ResponseDataRoleEnum];

export interface GetCurrentUser401Response {
    'success'?: boolean;
    'error'?: string;
    'message'?: string;
}
export interface GetCurrentUserProfile200Response {
    'success'?: boolean;
    'data'?: GetCurrentUserProfile200ResponseData;
}
export interface GetCurrentUserProfile200ResponseData {
    'id'?: string;
    'user_id'?: string;
    'phone'?: string;
    'address'?: string;
    'city'?: string;
    'country'?: string;
    'timezone'?: string;
    'language'?: string;
    'profile_metadata'?: object;
}
export interface GetIndices200ResponseInner {
    'symbol'?: string;
    'name'?: string;
    'exchange'?: string;
}
/**
 * Response schema for getting session messages.
 */
export interface GetSessionMessagesResponse {
    /**
     * ADK session ID
     */
    'session_id': string;
    /**
     * List of message events in chronological order
     */
    'messages': Array<MessageEvent>;
    /**
     * Total number of messages returned
     */
    'count': number;
}
export interface GetUserById200Response {
    'success'?: boolean;
    'data'?: object;
}
export interface GetUserCategories200Response {
    'success'?: boolean;
    'data'?: Array<GetUserCategories200ResponseDataInner>;
    'message'?: string;
}
export interface GetUserCategories200ResponseDataInner {
    'id'?: string;
    'name'?: string;
    'description'?: string;
    'is_active'?: boolean;
    'created_at'?: string;
    'updated_at'?: string;
}
export interface GetUserPreference200Response {
    'success'?: boolean;
    'data'?: GetUserPreferences200ResponseDataPreferencesInner;
}
export interface GetUserPreferences200Response {
    'success'?: boolean;
    'data'?: GetUserPreferences200ResponseData;
}
export interface GetUserPreferences200ResponseData {
    'preferences'?: Array<GetUserPreferences200ResponseDataPreferencesInner>;
}
export interface GetUserPreferences200ResponseDataPreferencesInner {
    'id'?: string;
    'preference_key'?: string;
    'preference_value'?: object;
}
export interface GetUserQuotas200Response {
    'success'?: boolean;
    'data'?: GetUserQuotas200ResponseData;
}
export interface GetUserQuotas200ResponseData {
    'strategies'?: GetUserQuotas200ResponseDataStrategies;
    'screeners'?: GetUserQuotas200ResponseDataStrategies;
}
export interface GetUserQuotas200ResponseDataStrategies {
    'current'?: number;
    'limit'?: number;
    'remaining'?: number;
    'can_create'?: boolean;
}
export interface GetWatchlistGroup200Response {
    'success'?: boolean;
    'data'?: WatchlistGroupResponse;
}
export interface GetWatchlistItem200Response {
    'success'?: boolean;
    'data'?: WatchlistItemResponse;
}
export interface HealthCheck200Response {
    'status'?: string;
    'service'?: string;
    'version'?: string;
    'timestamp'?: string;
}
/**
 * Portfolio holding.
 */
export interface HoldingResponse {
    [key: string]: any;

    'id': string;
    'firebase_uid': string;
    'broker_account_id': string;
    'instrument_id': string;
    'broker_type'?: string;
    'symbol'?: string;
    'exchange'?: string;
    'quantity': string;
    'available_quantity'?: string;
    'invested_value'?: string;
    'market_value': string;
    'unrealized_pnl'?: string;
    'unrealized_pnl_percentage'?: string;
    'day_change'?: string;
    'day_change_percentage'?: string;
    'last_synced_at'?: string;
}
export interface InstrumentBatchRequest {
    'instrument_ids': Array<string>;
    /**
     * Whether to include broker mappings in the response
     */
    'include_mappings'?: boolean;
    /**
     * Optional broker type to filter mappings by (e.g. \'zerodha\')
     */
    'broker_type'?: string;
}
/**
 * Instrument collection.
 */
export interface InstrumentListResponse {
    [key: string]: any;

    'instruments'?: Array<InstrumentResponse>;
    'total'?: number;
}
/**
 * Instrument master record. May include optional price information if market-data-service is available.
 */
export interface InstrumentResponse {
    [key: string]: any;

    'instrument_id': string;
    'symbol': string;
    'name'?: string;
    'instrument_type'?: string;
    'exchange': string;
    'segment'?: string | null;
    'currency'?: string;
    'lot_size'?: number | null;
    'tick_size'?: number | null;
    'is_active'?: boolean;
    'trading_status'?: string;
    'isin'?: string | null;
    'expiry_date'?: string | null;
    'strike_price'?: number | null;
    'option_type'?: string | null;
    'sector'?: string | null;
    'industry'?: string | null;
    'market_cap'?: number | null;
    'broker_mappings'?: Array<{ [key: string]: any; }> | null;
    'broker_mapping'?: { [key: string]: any; } | null;
    /**
     * Last traded price (display-only, not for financial transactions)
     */
    'last_price'?: string | null;
    /**
     * Price change from previous close
     */
    'change'?: string | null;
    /**
     * Price change percentage from previous close
     */
    'change_percentage'?: string | null;
    /**
     * Trading volume
     */
    'volume'?: number | null;
    /**
     * Open price
     */
    'open'?: string | null;
    /**
     * High price
     */
    'high'?: string | null;
    /**
     * Low price
     */
    'low'?: string | null;
    /**
     * Close price
     */
    'close'?: string | null;
    /**
     * Timestamp of the price data
     */
    'price_timestamp'?: string | null;
    /**
     * Source of the price data (e.g., yahoo_finance)
     */
    'data_source'?: string | null;
    /**
     * True if price data is delayed
     */
    'is_delayed'?: boolean | null;
    /**
     * Delay in minutes if data is delayed
     */
    'delay_minutes'?: number | null;
}
export interface InstrumentTokenResolveBatch200Response {
    'results': Array<TokenResolutionResponse>;
}
export interface InstrumentTokenResolveBatchRequest {
    'items': Array<InstrumentTokenResolveBatchRequestItemsInner>;
}
export interface InstrumentTokenResolveBatchRequestItemsInner {
    'broker': string;
    'token': string;
    'exchange'?: string;
}
/**
 * Response schema for listing ADK sessions.
 */
export interface ListSessionsResponse {
    /**
     * List of session information with display names for the authenticated user
     */
    'sessions': Array<SessionInfo>;
    /**
     * Total number of sessions returned
     */
    'count': number;
}
export interface ListUsers200Response {
    'success'?: boolean;
    'data'?: ListUsers200ResponseData;
}
export interface ListUsers200ResponseData {
    'users'?: Array<ListUsers200ResponseDataUsersInner>;
    'total'?: number;
    'page'?: number;
    'size'?: number;
    'pages'?: number;
}
export interface ListUsers200ResponseDataUsersInner {
    'id'?: string;
    'email'?: string;
    'first_name'?: string;
    'last_name'?: string;
    'status'?: string;
    'is_active'?: boolean;
    'role'?: ListUsers200ResponseDataUsersInnerRoleEnum;
    'category_id'?: string;
    'created_at'?: string;
}

export const ListUsers200ResponseDataUsersInnerRoleEnum = {
    User: 'user',
    Admin: 'admin'
} as const;

export type ListUsers200ResponseDataUsersInnerRoleEnum = typeof ListUsers200ResponseDataUsersInnerRoleEnum[keyof typeof ListUsers200ResponseDataUsersInnerRoleEnum];

/**
 * Schema for a single message event in a session.
 */
export interface MessageEvent {
    /**
     * Event ID
     */
    'id': string;
    /**
     * Author of the message (e.g., \'user\', \'assistant\')
     */
    'author': string;
    /**
     * Message content
     */
    'content': string;
    /**
     * Event timestamp in ISO 8601 format (optional)
     */
    'timestamp'?: string | null;
}
/**
 * Response for migration from OAuth to TOTP authentication.
 */
export interface MigrateToTOTPResponse {
    /**
     * Account registration ID
     */
    'registration_id': string;
    /**
     * Migration status (migrated, error)
     */
    'status': string;
    /**
     * Authentication mode after migration (always \'totp_automated\')
     */
    'auth_mode': string;
    /**
     * Timestamp when migration was completed
     */
    'migrated_at': string;
    /**
     * Status message
     */
    'message': string;
}
/**
 * Order representation returned by order-service.
 */
export interface OrderResponse {
    [key: string]: any;

    'platform_order_id': string;
    'firebase_uid': string;
    'instrument_id': string;
    'broker_order_id'?: string;
    'side'?: string;
    'quantity': string;
    'filled_quantity': string;
    'remaining_quantity': string;
    'order_type': string;
    'time_in_force'?: string;
    'status': string;
    'priority': number;
    'market_session'?: string;
    'price'?: string;
    'stop_price'?: string;
    'limit_price'?: string;
    'created_at': string;
    'updated_at': string;
    'expires_at'?: string;
    'broker_order'?: { [key: string]: any; } | null;
    'fills'?: Array<{ [key: string]: any; }>;
}
export interface OrdersBatch200Response {
    'total': number;
    'success': number;
    'failed': number;
    'results': Array<{ [key: string]: any; }>;
}
export interface OrdersBatchRequest {
    /**
     * List of orders to place (max 100)
     */
    'orders': Array<{ [key: string]: any; }>;
}
/**
 * Order creation payload. Additional optional fields are permitted.
 */
export interface OrdersCreateRequest {
    [key: string]: any;

    /**
     * Instrument identifier
     */
    'instrument_id': string;
    /**
     * Linked broker account identifier
     */
    'broker_account_id': string;
    /**
     * Broker type (zerodha, dhan, alpaca, interactive_brokers)
     */
    'broker_type': string;
    /**
     * Order side (buy, sell, short, cover)
     */
    'side': string;
    /**
     * Order quantity as decimal string
     */
    'quantity': string;
    /**
     * Order type (market, limit, stop, stop_limit, trailing_stop, iceberg, twap, vwap)
     */
    'order_type': string;
    /**
     * Optional price for limit/stop orders
     */
    'price'?: string;
    /**
     * Optional stop trigger price
     */
    'stop_price'?: string;
    /**
     * Time in force (day, gtc, ioc, fok, gtd)
     */
    'time_in_force'?: string;
    /**
     * Optional client reference
     */
    'client_order_id'?: string;
    /**
     * Strategy identifier if order belongs to a strategy
     */
    'strategy_id'?: string;
    /**
     * Encrypted user notes
     */
    'notes'?: string;
    /**
     * Custom metadata tags
     */
    'order_tags'?: object;
    /**
     * Broker routing preferences
     */
    'routing_preferences'?: object;
}
export interface OrdersList200Response {
    'orders': Array<OrderResponse>;
    'total': number;
    'limit': number;
    'offset': number;
}
/**
 * Order modification payload. All fields are optional.
 */
export interface OrdersModifyRequest {
    [key: string]: any;

    /**
     * Updated order quantity as decimal string
     */
    'quantity'?: string;
    /**
     * Updated order price as decimal string
     */
    'price'?: string;
    /**
     * Updated stop price as decimal string
     */
    'stop_price'?: string;
    /**
     * Updated limit price as decimal string
     */
    'limit_price'?: string;
    /**
     * Updated user notes
     */
    'notes'?: string;
}
export interface OrdersTimeline200Response {
    'platform_order_id': string;
    'events': Array<OrdersTimeline200ResponseEventsInner>;
    'total_events': number;
}
export interface OrdersTimeline200ResponseEventsInner {
    /**
     * Event type (order_created, status_change, fill, broker_sync)
     */
    'event_type': string;
    'timestamp': string;
    'old_status'?: string;
    'new_status'?: string;
    'description': string;
    'changed_by'?: string;
    'metadata'?: { [key: string]: any; };
}
export interface PortfolioAccountDelete200Response {
    /**
     * Whether deletion was successful
     */
    'success': boolean;
    /**
     * Broker account identifier
     */
    'broker_account_id': string;
    /**
     * Number of holdings deleted
     */
    'holdings_deleted': number;
    /**
     * Number of transactions deleted
     */
    'transactions_deleted': number;
    /**
     * Status message
     */
    'message': string;
}
export interface PortfolioGet200Response {
    'firebase_uid': string;
    'total_accounts': number;
    'total_holdings': number;
    'portfolio_summary': PortfolioGet200ResponsePortfolioSummary;
    'broker_accounts': Array<{ [key: string]: any; }>;
    'top_holdings': Array<{ [key: string]: any; }>;
    'last_updated': string;
}
export interface PortfolioGet200ResponsePortfolioSummary {
    'total_market_value'?: string;
    'total_invested_value'?: string;
    'total_unrealized_pnl'?: string;
    'total_unrealized_pnl_percentage'?: string;
    'total_day_change'?: string;
    'total_day_change_percentage'?: string;
}
export interface PortfolioHoldingsList200Response {
    'holdings': Array<HoldingResponse>;
    'total_count': number;
}
export interface PortfolioSync200Response {
    'sync_id'?: string;
    'broker_account_id'?: string;
    'sync_type'?: string;
    'sync_status'?: string;
    'sync_started_at'?: string;
    'message'?: string;
    'accounts_synced'?: number;
    'results'?: Array<PortfolioSync200ResponseResultsInner>;
}
export interface PortfolioSync200ResponseResultsInner {
    'sync_id'?: string;
    'broker_account_id'?: string;
    'sync_type'?: string;
    'sync_status'?: string;
    'sync_started_at'?: string;
    'message'?: string;
}
export interface PortfolioSyncRequest {
    /**
     * Optional. If omitted, sync all connected accounts; if set, sync only this account.
     */
    'broker_account_id'?: string;
    /**
     * Sync type (full, incremental)
     */
    'sync_type'?: PortfolioSyncRequestSyncTypeEnum;
    /**
     * Sync scope
     */
    'sync_scope'?: PortfolioSyncRequestSyncScopeEnum;
    /**
     * Force sync even if recently synced
     */
    'force'?: boolean;
}

export const PortfolioSyncRequestSyncTypeEnum = {
    Full: 'full',
    Incremental: 'incremental'
} as const;

export type PortfolioSyncRequestSyncTypeEnum = typeof PortfolioSyncRequestSyncTypeEnum[keyof typeof PortfolioSyncRequestSyncTypeEnum];
export const PortfolioSyncRequestSyncScopeEnum = {
    HoldingsOnly: 'holdings_only',
    TransactionsOnly: 'transactions_only',
    Both: 'both'
} as const;

export type PortfolioSyncRequestSyncScopeEnum = typeof PortfolioSyncRequestSyncScopeEnum[keyof typeof PortfolioSyncRequestSyncScopeEnum];

export interface PortfolioTransactionsList200Response {
    'transactions': Array<TransactionResponse>;
    'total_count': number;
}
/**
 * Broker reconnection response. Supports both OAuth and TOTP automated authentication.
 */
export interface ReconnectResponse {
    /**
     * Account registration ID
     */
    'registration_id': string;
    /**
     * Broker account identifier
     */
    'broker_account_id': string;
    /**
     * New connection status (active, oauth_required, connected)
     */
    'connection_status': string;
    /**
     * Whether reconnection was successful
     */
    'is_connected': boolean;
    /**
     * Reconnection timestamp
     */
    'reconnected_at': string;
    /**
     * Whether OAuth token was refreshed (or access token updated for TOTP)
     */
    'token_refreshed': boolean;
    /**
     * Reconnection status message
     */
    'message': string;
    /**
     * Authentication mode: \'oauth\' or \'totp_automated\'
     */
    'auth_mode'?: string | null;
    /**
     * OAuth URL for reconnection (if OAuth required, null for TOTP automated)
     */
    'oauth_url'?: string | null;
    /**
     * OAuth state for reconnection (if OAuth required, null for TOTP automated)
     */
    'oauth_state'?: string | null;
    /**
     * Status of reconnection (oauth_required, completed, connected, failed)
     */
    'status'?: string | null;
}
/**
 * Response for TOTP-based broker registration.
 */
export interface RegisterTOTPResponse {
    /**
     * Account registration ID
     */
    'registration_id': string;
    /**
     * Account status (connected, pending, error)
     */
    'status': string;
    /**
     * Broker account identifier - maps from account_id field (e.g., Zerodha client ID, Groww email/user ID)
     */
    'broker_account_id': string;
    /**
     * Authentication mode (always \'totp_automated\' for this endpoint)
     */
    'auth_mode': string;
    /**
     * Status message
     */
    'message'?: string | null;
}
/**
 * Schema for session information including display name.
 */
export interface SessionInfo {
    /**
     * ADK session_id (simple string ID, e.g., \'123456789\' or \'custom-session-123\')
     */
    'session_id': string;
    /**
     * Custom display name for the session (optional, null if not set)
     */
    'display_name'?: string | null;
}
export interface SetUserPreferenceRequest {
    'preference_value': object;
}
/**
 * List of supported broker platforms.
 */
export interface SupportedBrokersResponse {
    /**
     * List of supported broker platforms
     */
    'brokers': Array<BrokerMetadataResponse>;
    /**
     * Total number of supported brokers
     */
    'total': number;
}
/**
 * Broker token resolution result.
 */
export interface TokenResolutionResponse {
    [key: string]: any;

    'broker'?: string;
    'token'?: string;
    'instrument_id'?: string;
    'symbol'?: string;
    'exchange'?: string;
    'status'?: string;
}
/**
 * Portfolio transaction.
 */
export interface TransactionResponse {
    [key: string]: any;

    'id': string;
    'firebase_uid': string;
    'broker_account_id': string;
    'instrument_id': string;
    'broker_type'?: string;
    'transaction_type': string;
    'transaction_date': string;
    'trade_date'?: string;
    'quantity': string;
    'price': string;
    'transaction_value'?: string;
    'total_charges'?: string;
    'net_amount'?: string;
}
export interface UpdateBrokerStatusRequest {
    'is_active': boolean;
}
/**
 * Response for TOTP credentials update.
 */
export interface UpdateCredentialsResponse {
    /**
     * Account registration ID
     */
    'registration_id': string;
    /**
     * Update status (success, error)
     */
    'status': string;
    /**
     * Timestamp when credentials were updated
     */
    'updated_at': string;
    /**
     * Status message
     */
    'message': string;
}
export interface UpdateCurrentUserProfileRequest {
    'phone'?: string;
    'address'?: string;
    'city'?: string;
    'country'?: string;
    'timezone'?: string;
    'language'?: string;
    'profile_metadata'?: object;
}
/**
 * Request schema for updating session display name.
 */
export interface UpdateSessionDisplayNameRequest {
    /**
     * New display name for the session (cannot be empty)
     */
    'display_name': string;
}
export interface UpdateUserCategoryRequest {
    'name'?: string;
    'description'?: string;
    'is_active'?: boolean;
}
/**
 * Request schema for updating a watchlist group.
 */
export interface UpdateWatchlistGroupRequest {
    /**
     * Group name
     */
    'name'?: string;
    /**
     * Display order (lower numbers appear first)
     */
    'display_order'?: number;
    /**
     * Whether this is the default group
     */
    'is_default'?: boolean;
}
/**
 * Request schema for updating a watchlist item.
 */
export interface UpdateWatchlistItemRequest {
    /**
     * Display order within group
     */
    'display_order': number;
}
/**
 * Response schema for watchlist group.
 */
export interface WatchlistGroupResponse {
    /**
     * Group identifier
     */
    'id': string;
    /**
     * Group name
     */
    'name': string;
    /**
     * Display order
     */
    'display_order': number;
    /**
     * Whether this is the default group
     */
    'is_default': boolean;
    /**
     * Creation timestamp
     */
    'created_at'?: string;
    /**
     * Last update timestamp
     */
    'updated_at'?: string;
}
/**
 * Response schema for list of watchlist groups.
 */
export interface WatchlistGroupsListResponse {
    /**
     * List of watchlist groups
     */
    'groups': Array<WatchlistGroupResponse>;
}
/**
 * Response schema for watchlist item.
 */
export interface WatchlistItemResponse {
    /**
     * Item identifier
     */
    'id': string;
    /**
     * Instrument UUID
     */
    'instrument_id': string;
    /**
     * Display order within group
     */
    'display_order': number;
    /**
     * When item was added to watchlist
     */
    'added_at'?: string;
    /**
     * Creation timestamp
     */
    'created_at'?: string;
    /**
     * Last update timestamp
     */
    'updated_at'?: string;
}
/**
 * Response schema for list of watchlist items.
 */
export interface WatchlistItemsListResponse {
    /**
     * List of watchlist items
     */
    'items': Array<WatchlistItemResponse>;
}

/**
 * DefaultApi - axios parameter creator
 */
export const DefaultApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Registers a new supported broker. Admin only.
         * @summary Add a supported broker
         * @param {AddSupportedBrokerRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addSupportedBroker: async (body: AddSupportedBrokerRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'body' is not null or undefined
            assertParamExists('addSupportedBroker', 'body', body)
            const localVarPath = `/api/v1/broker-accounts/supported-brokers`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication firebase_jwt required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "firebase_jwt", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Add instrument to watchlist group
         * @param {string} groupId 
         * @param {AddWatchlistItemRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addWatchlistItem: async (groupId: string, body: AddWatchlistItemRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'groupId' is not null or undefined
            assertParamExists('addWatchlistItem', 'groupId', groupId)
            // verify required parameter 'body' is not null or undefined
            assertParamExists('addWatchlistItem', 'body', body)
            const localVarPath = `/api/v1/users/me/watchlist/groups/{group_id}/items`
                .replace(`{${"group_id"}}`, encodeURIComponent(String(groupId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication firebase_jwt required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "firebase_jwt", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Send AG-UI RunAgentInput request and stream AG-UI protocol events (SSE or JSON-lines format). Uses AG-UI protocol libraries for request/response handling.
         * @summary AG-UI protocol endpoint - stream agent responses
         * @param {AiAssistAguiStreamRequest} body AG-UI RunAgentInput request (from @ag-ui/core library)
         * @param {string} [accept] Response format: \&#39;text/event-stream\&#39; (SSE) or \&#39;application/x-ndjson\&#39; (JSON-lines)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        aiAssistAguiStream: async (body: AiAssistAguiStreamRequest, accept?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'body' is not null or undefined
            assertParamExists('aiAssistAguiStream', 'body', body)
            const localVarPath = `/api/v1/ai-assist/agui`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication firebase_jwt required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "firebase_jwt", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (accept != null) {
                localVarHeaderParameter['Accept'] = String(accept);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Delete a session from Vertex AI Agent Engine. This permanently removes the session and all its associated messages.
         * @summary Delete an ADK session
         * @param {string} sessionId ADK session ID to delete
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        aiAssistSessionDelete: async (sessionId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'sessionId' is not null or undefined
            assertParamExists('aiAssistSessionDelete', 'sessionId', sessionId)
            const localVarPath = `/api/v1/ai-assist/sessions/{session_id}`
                .replace(`{${"session_id"}}`, encodeURIComponent(String(sessionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication firebase_jwt required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "firebase_jwt", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieve all messages (events) associated with a specific session from Vertex AI Agent Engine. The messages are returned in chronological order.
         * @summary Get message history for a specific ADK session
         * @param {string} sessionId ADK session ID to retrieve messages for
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        aiAssistSessionMessagesGet: async (sessionId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'sessionId' is not null or undefined
            assertParamExists('aiAssistSessionMessagesGet', 'sessionId', sessionId)
            const localVarPath = `/api/v1/ai-assist/sessions/{session_id}/messages`
                .replace(`{${"session_id"}}`, encodeURIComponent(String(sessionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication firebase_jwt required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "firebase_jwt", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update the display name for a session. The session_id itself cannot be changed, but a custom display name can be stored and displayed in the UI.
         * @summary Update session display name
         * @param {string} sessionId ADK session ID to update
         * @param {UpdateSessionDisplayNameRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        aiAssistSessionUpdate: async (sessionId: string, body: UpdateSessionDisplayNameRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'sessionId' is not null or undefined
            assertParamExists('aiAssistSessionUpdate', 'sessionId', sessionId)
            // verify required parameter 'body' is not null or undefined
            assertParamExists('aiAssistSessionUpdate', 'body', body)
            const localVarPath = `/api/v1/ai-assist/sessions/{session_id}`
                .replace(`{${"session_id"}}`, encodeURIComponent(String(sessionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication firebase_jwt required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "firebase_jwt", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Create a new ADK session in Vertex AI Agent Engine. The returned session_id should be used in all subsequent AG-UI requests (via threadId field) to maintain conversation continuity across multiple user messages.
         * @summary Create ADK session for conversation continuity
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        aiAssistSessionsCreate: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/ai-assist/sessions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication firebase_jwt required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "firebase_jwt", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieve all sessions associated with the authenticated user from Vertex AI Agent Engine. Sessions are returned as a list of session IDs that can be used for conversation continuity.
         * @summary List all ADK sessions for the authenticated user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        aiAssistSessionsList: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/ai-assist/sessions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication firebase_jwt required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "firebase_jwt", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Disconnect a broker account from the platform.
         * @summary Disconnect broker account
         * @param {BrokerAccountDisconnectRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        brokerAccountDisconnect: async (body: BrokerAccountDisconnectRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'body' is not null or undefined
            assertParamExists('brokerAccountDisconnect', 'body', body)
            const localVarPath = `/api/v1/broker-accounts/disconnect`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication firebase_jwt required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "firebase_jwt", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieve a single broker account.
         * @summary Get broker account
         * @param {string} accountId Broker account identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        brokerAccountGet: async (accountId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'accountId' is not null or undefined
            assertParamExists('brokerAccountGet', 'accountId', accountId)
            const localVarPath = `/api/v1/broker-accounts/accounts/{account_id}`
                .replace(`{${"account_id"}}`, encodeURIComponent(String(accountId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication firebase_jwt required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "firebase_jwt", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update broker account preferences.
         * @summary Update broker account
         * @param {string} accountId Broker account identifier
         * @param {BrokerAccountUpdateRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        brokerAccountUpdate: async (accountId: string, body: BrokerAccountUpdateRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'accountId' is not null or undefined
            assertParamExists('brokerAccountUpdate', 'accountId', accountId)
            // verify required parameter 'body' is not null or undefined
            assertParamExists('brokerAccountUpdate', 'body', body)
            const localVarPath = `/api/v1/broker-accounts/accounts/{account_id}`
                .replace(`{${"account_id"}}`, encodeURIComponent(String(accountId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication firebase_jwt required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "firebase_jwt", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * List broker accounts linked to the authenticated user.
         * @summary List broker accounts
         * @param {string} [brokerType] Filter by broker type
         * @param {string} [status] Filter by account status
         * @param {boolean} [paperTrading] Filter by paper trading mode
         * @param {number} [limit] Maximum number of results
         * @param {number} [offset] Pagination offset
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        brokerAccountsList: async (brokerType?: string, status?: string, paperTrading?: boolean, limit?: number, offset?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/broker-accounts/accounts`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication firebase_jwt required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "firebase_jwt", [], configuration)

            if (brokerType !== undefined) {
                localVarQueryParameter['broker_type'] = brokerType;
            }

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }

            if (paperTrading !== undefined) {
                localVarQueryParameter['paper_trading'] = paperTrading;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get list of all supported broker platforms. Public endpoint - no authentication required.
         * @summary Get supported brokers
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        brokerAccountsSupportedBrokers: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/broker-accounts/supported-brokers`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Initiate broker account registration and OAuth flow.
         * @summary Register broker account
         * @param {BrokerRegistrationRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        brokerRegistration: async (body: BrokerRegistrationRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'body' is not null or undefined
            assertParamExists('brokerRegistration', 'body', body)
            const localVarPath = `/api/v1/broker-registration/register`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication firebase_jwt required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "firebase_jwt", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Handle OAuth callbacks from broker partners. Public endpoint invoked by brokers.
         * @summary Broker OAuth callback
         * @param {string} brokerType Broker identifier
         * @param {string} [state] 
         * @param {string} [oauthState] 
         * @param {string} [code] 
         * @param {string} [requestToken] 
         * @param {string} [action] 
         * @param {string} [status] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        brokerRegistrationCallback: async (brokerType: string, state?: string, oauthState?: string, code?: string, requestToken?: string, action?: string, status?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'brokerType' is not null or undefined
            assertParamExists('brokerRegistrationCallback', 'brokerType', brokerType)
            const localVarPath = `/api/v1/broker-registration/oauth/{broker_type}/callback`
                .replace(`{${"broker_type"}}`, encodeURIComponent(String(brokerType)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (state !== undefined) {
                localVarQueryParameter['state'] = state;
            }

            if (oauthState !== undefined) {
                localVarQueryParameter['oauth_state'] = oauthState;
            }

            if (code !== undefined) {
                localVarQueryParameter['code'] = code;
            }

            if (requestToken !== undefined) {
                localVarQueryParameter['request_token'] = requestToken;
            }

            if (action !== undefined) {
                localVarQueryParameter['action'] = action;
            }

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Deregister and delete a broker account by registration ID.
         * @summary Deregister broker account
         * @param {string} registrationId Registration identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        brokerRegistrationDeregister: async (registrationId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'registrationId' is not null or undefined
            assertParamExists('brokerRegistrationDeregister', 'registrationId', registrationId)
            const localVarPath = `/api/v1/broker-registration/deregister/{registration_id}`
                .replace(`{${"registration_id"}}`, encodeURIComponent(String(registrationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication firebase_jwt required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "firebase_jwt", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Migrate existing OAuth account to TOTP-based automated authentication. Verifies account ownership and current auth_mode=\'oauth\', validates TOTP secret format, stores credentials in Secret Manager, performs one-time validation login, and updates account to TOTP mode if successful. Existing access token is preserved during migration.
         * @summary Migrate existing OAuth account to TOTP-based automated authentication
         * @param {string} registrationId Registration identifier
         * @param {BrokerRegistrationMigrateToTOTPRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        brokerRegistrationMigrateToTOTP: async (registrationId: string, body: BrokerRegistrationMigrateToTOTPRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'registrationId' is not null or undefined
            assertParamExists('brokerRegistrationMigrateToTOTP', 'registrationId', registrationId)
            // verify required parameter 'body' is not null or undefined
            assertParamExists('brokerRegistrationMigrateToTOTP', 'body', body)
            const localVarPath = `/api/v1/broker-registration/{registration_id}/migrate-to-totp`
                .replace(`{${"registration_id"}}`, encodeURIComponent(String(registrationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication firebase_jwt required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "firebase_jwt", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Reconnect broker account. Routes to automated TOTP login or OAuth flow based on account auth_mode. If auth_mode=\'totp_automated\', performs automated login using stored TOTP credentials. If auth_mode=\'oauth\', returns OAuth URL for manual login.
         * @summary Reconnect broker account
         * @param {BrokerRegistrationReconnectRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        brokerRegistrationReconnect: async (body: BrokerRegistrationReconnectRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'body' is not null or undefined
            assertParamExists('brokerRegistrationReconnect', 'body', body)
            const localVarPath = `/api/v1/broker-registration/reconnect`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication firebase_jwt required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "firebase_jwt", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Check the status of a broker registration flow.
         * @summary Get registration status
         * @param {string} registrationId Registration identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        brokerRegistrationStatus: async (registrationId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'registrationId' is not null or undefined
            assertParamExists('brokerRegistrationStatus', 'registrationId', registrationId)
            const localVarPath = `/api/v1/broker-registration/status/{registration_id}`
                .replace(`{${"registration_id"}}`, encodeURIComponent(String(registrationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication firebase_jwt required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "firebase_jwt", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Register broker account with TOTP credentials for automated authentication. Supports any broker that implements automated login (e.g., Zerodha, Groww). Stores credentials securely in GCP Secret Manager, creates account record, performs one-time validation login, and returns registration details if successful. If validation fails, credentials are automatically cleaned up.
         * @summary Register broker account with TOTP credentials
         * @param {BrokerRegistrationTOTPRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        brokerRegistrationTOTP: async (body: BrokerRegistrationTOTPRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'body' is not null or undefined
            assertParamExists('brokerRegistrationTOTP', 'body', body)
            const localVarPath = `/api/v1/broker-registration/register-totp`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication firebase_jwt required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "firebase_jwt", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update TOTP credentials for an existing account. Verifies account ownership, validates new credentials format, updates credentials in Secret Manager, performs validation login with new credentials, and updates account metadata if successful. Requires account to be in TOTP mode (auth_mode=\'totp_automated\').
         * @summary Update TOTP credentials for existing account
         * @param {string} registrationId Registration identifier
         * @param {BrokerRegistrationUpdateTOTPCredentialsRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        brokerRegistrationUpdateTOTPCredentials: async (registrationId: string, body: BrokerRegistrationUpdateTOTPCredentialsRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'registrationId' is not null or undefined
            assertParamExists('brokerRegistrationUpdateTOTPCredentials', 'registrationId', registrationId)
            // verify required parameter 'body' is not null or undefined
            assertParamExists('brokerRegistrationUpdateTOTPCredentials', 'body', body)
            const localVarPath = `/api/v1/broker-registration/{registration_id}/totp-credentials`
                .replace(`{${"registration_id"}}`, encodeURIComponent(String(registrationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication firebase_jwt required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "firebase_jwt", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Updates a user\'s role. Caller must have the \'admin\' role — enforced server-side.
         * @summary Change user role (admin only)
         * @param {string} userId Target user\&#39;s UUID
         * @param {ChangeUserRoleRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        changeUserRole: async (userId: string, body: ChangeUserRoleRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('changeUserRole', 'userId', userId)
            // verify required parameter 'body' is not null or undefined
            assertParamExists('changeUserRole', 'body', body)
            const localVarPath = `/api/v1/users/{user_id}/role`
                .replace(`{${"user_id"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication firebase_jwt required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "firebase_jwt", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Check quota for resource type
         * @param {string} userId 
         * @param {CheckUserQuotaResourceTypeEnum} resourceType 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkUserQuota: async (userId: string, resourceType: CheckUserQuotaResourceTypeEnum, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('checkUserQuota', 'userId', userId)
            // verify required parameter 'resourceType' is not null or undefined
            assertParamExists('checkUserQuota', 'resourceType', resourceType)
            const localVarPath = `/api/v1/users/{user_id}/quotas/check`
                .replace(`{${"user_id"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication firebase_jwt required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "firebase_jwt", [], configuration)

            if (resourceType !== undefined) {
                localVarQueryParameter['resource_type'] = resourceType;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create user
         * @param {CreateUserRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createUser: async (body: CreateUserRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'body' is not null or undefined
            assertParamExists('createUser', 'body', body)
            const localVarPath = `/api/v1/users`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication firebase_jwt required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "firebase_jwt", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Create a new user category (admin only).
         * @summary Create user category
         * @param {CreateUserCategoryRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createUserCategory: async (body: CreateUserCategoryRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'body' is not null or undefined
            assertParamExists('createUserCategory', 'body', body)
            const localVarPath = `/api/v1/users/categories`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication firebase_jwt required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "firebase_jwt", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create watchlist group
         * @param {CreateWatchlistGroupRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createWatchlistGroup: async (body: CreateWatchlistGroupRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'body' is not null or undefined
            assertParamExists('createWatchlistGroup', 'body', body)
            const localVarPath = `/api/v1/users/me/watchlist/groups`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication firebase_jwt required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "firebase_jwt", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete user (soft delete)
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteUser: async (userId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('deleteUser', 'userId', userId)
            const localVarPath = `/api/v1/users/{user_id}`
                .replace(`{${"user_id"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication firebase_jwt required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "firebase_jwt", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete watchlist group
         * @param {string} groupId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteWatchlistGroup: async (groupId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'groupId' is not null or undefined
            assertParamExists('deleteWatchlistGroup', 'groupId', groupId)
            const localVarPath = `/api/v1/users/me/watchlist/groups/{group_id}`
                .replace(`{${"group_id"}}`, encodeURIComponent(String(groupId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication firebase_jwt required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "firebase_jwt", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Detailed health check
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        detailedHealthCheck: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/health/detailed`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get all watchlist groups
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllWatchlistGroups: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/users/me/watchlist/groups`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication firebase_jwt required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "firebase_jwt", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get all watchlist items in group
         * @param {string} groupId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllWatchlistItems: async (groupId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'groupId' is not null or undefined
            assertParamExists('getAllWatchlistItems', 'groupId', groupId)
            const localVarPath = `/api/v1/users/me/watchlist/groups/{group_id}/items`
                .replace(`{${"group_id"}}`, encodeURIComponent(String(groupId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication firebase_jwt required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "firebase_jwt", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get current user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCurrentUser: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/users/me`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication firebase_jwt required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "firebase_jwt", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get current user\'s profile
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCurrentUserProfile: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/users/me/profile`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication firebase_jwt required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "firebase_jwt", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieve the instruments that make up a specific index.
         * @summary Get index constituents
         * @param {string} indexSymbol Index symbol (e.g., NIFTY 50)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getIndexConstituents: async (indexSymbol: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'indexSymbol' is not null or undefined
            assertParamExists('getIndexConstituents', 'indexSymbol', indexSymbol)
            const localVarPath = `/api/v1/indices/{index_symbol}/instruments`
                .replace(`{${"index_symbol"}}`, encodeURIComponent(String(indexSymbol)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication firebase_jwt required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "firebase_jwt", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieve a list of all available market indices.
         * @summary Get all indices
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getIndices: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/indices`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication firebase_jwt required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "firebase_jwt", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get user by ID
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserById: async (userId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('getUserById', 'userId', userId)
            const localVarPath = `/api/v1/users/{user_id}`
                .replace(`{${"user_id"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication firebase_jwt required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "firebase_jwt", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * List all user categories (admin only). Reference data.
         * @summary List user categories
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserCategories: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/users/categories`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication firebase_jwt required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "firebase_jwt", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get preference by key
         * @param {string} userId 
         * @param {string} key 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserPreference: async (userId: string, key: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('getUserPreference', 'userId', userId)
            // verify required parameter 'key' is not null or undefined
            assertParamExists('getUserPreference', 'key', key)
            const localVarPath = `/api/v1/users/{user_id}/preferences/{key}`
                .replace(`{${"user_id"}}`, encodeURIComponent(String(userId)))
                .replace(`{${"key"}}`, encodeURIComponent(String(key)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication firebase_jwt required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "firebase_jwt", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get all user preferences
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserPreferences: async (userId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('getUserPreferences', 'userId', userId)
            const localVarPath = `/api/v1/users/{user_id}/preferences`
                .replace(`{${"user_id"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication firebase_jwt required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "firebase_jwt", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get user profile by user ID or Firebase UID
         * @param {string} userId User ID (UUID) or Firebase UID. If Firebase UID is provided, user will be looked up first.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserProfile: async (userId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('getUserProfile', 'userId', userId)
            const localVarPath = `/api/v1/users/{user_id}/profile`
                .replace(`{${"user_id"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication firebase_jwt required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "firebase_jwt", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get user quotas
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserQuotas: async (userId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('getUserQuotas', 'userId', userId)
            const localVarPath = `/api/v1/users/{user_id}/quotas`
                .replace(`{${"user_id"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication firebase_jwt required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "firebase_jwt", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get watchlist group
         * @param {string} groupId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWatchlistGroup: async (groupId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'groupId' is not null or undefined
            assertParamExists('getWatchlistGroup', 'groupId', groupId)
            const localVarPath = `/api/v1/users/me/watchlist/groups/{group_id}`
                .replace(`{${"group_id"}}`, encodeURIComponent(String(groupId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication firebase_jwt required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "firebase_jwt", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get watchlist item
         * @param {string} groupId 
         * @param {string} itemId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWatchlistItem: async (groupId: string, itemId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'groupId' is not null or undefined
            assertParamExists('getWatchlistItem', 'groupId', groupId)
            // verify required parameter 'itemId' is not null or undefined
            assertParamExists('getWatchlistItem', 'itemId', itemId)
            const localVarPath = `/api/v1/users/me/watchlist/groups/{group_id}/items/{item_id}`
                .replace(`{${"group_id"}}`, encodeURIComponent(String(groupId)))
                .replace(`{${"item_id"}}`, encodeURIComponent(String(itemId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication firebase_jwt required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "firebase_jwt", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Basic health check
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        healthCheck: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/health`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Fetch multiple instruments by ID in a single request.
         * @summary Batch fetch instruments
         * @param {InstrumentBatchRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        instrumentBatch: async (body: InstrumentBatchRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'body' is not null or undefined
            assertParamExists('instrumentBatch', 'body', body)
            const localVarPath = `/api/v1/instruments/batch`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication firebase_jwt required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "firebase_jwt", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieve futures instruments for a symbol.
         * @summary Get futures instruments
         * @param {string} symbol 
         * @param {string} [exchange] Exchange (default: NFO). Optional.
         * @param {string} [expiryStart] Start of expiry date range (YYYY-MM-DD)
         * @param {string} [expiryEnd] End of expiry date range (YYYY-MM-DD)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        instrumentFutures: async (symbol: string, exchange?: string, expiryStart?: string, expiryEnd?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'symbol' is not null or undefined
            assertParamExists('instrumentFutures', 'symbol', symbol)
            const localVarPath = `/api/v1/instruments/futures`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication firebase_jwt required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "firebase_jwt", [], configuration)

            if (symbol !== undefined) {
                localVarQueryParameter['symbol'] = symbol;
            }

            if (exchange !== undefined) {
                localVarQueryParameter['exchange'] = exchange;
            }

            if (expiryStart !== undefined) {
                localVarQueryParameter['expiry_start'] = (expiryStart as any instanceof Date) ?
                    (expiryStart as any).toISOString().substring(0,10) :
                    expiryStart;
            }

            if (expiryEnd !== undefined) {
                localVarQueryParameter['expiry_end'] = (expiryEnd as any instanceof Date) ?
                    (expiryEnd as any).toISOString().substring(0,10) :
                    expiryEnd;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Fetch instrument master data by instrument identifier.
         * @summary Get instrument
         * @param {string} instrumentId Instrument identifier
         * @param {boolean} [includeMappings] Whether to include broker mappings in the response
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        instrumentGet: async (instrumentId: string, includeMappings?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'instrumentId' is not null or undefined
            assertParamExists('instrumentGet', 'instrumentId', instrumentId)
            const localVarPath = `/api/v1/instruments/{instrument_id}`
                .replace(`{${"instrument_id"}}`, encodeURIComponent(String(instrumentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication firebase_jwt required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "firebase_jwt", [], configuration)

            if (includeMappings !== undefined) {
                localVarQueryParameter['include_mappings'] = includeMappings;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get broker-specific instrument token from symbol and broker type. Reverse operation of token resolution. Used when user selects an instrument symbol and needs the broker-specific token for their broker account.
         * @summary Get broker token by symbol
         * @param {string} symbol Trading symbol (e.g., \&#39;INFY\&#39;)
         * @param {string} broker Broker type (zerodha, upstox, dhan, etc.)
         * @param {string} [exchange] Exchange code (e.g., \&#39;NSE\&#39;, \&#39;BSE\&#39;). Optional, searches all if not provided.
         * @param {string} [expiryDate] Expiry date for derivatives (YYYY-MM-DD)
         * @param {number} [strikePrice] Strike price for options
         * @param {InstrumentGetTokenBySymbolOptionTypeEnum} [optionType] Option type (CE/PE) for options
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        instrumentGetTokenBySymbol: async (symbol: string, broker: string, exchange?: string, expiryDate?: string, strikePrice?: number, optionType?: InstrumentGetTokenBySymbolOptionTypeEnum, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'symbol' is not null or undefined
            assertParamExists('instrumentGetTokenBySymbol', 'symbol', symbol)
            // verify required parameter 'broker' is not null or undefined
            assertParamExists('instrumentGetTokenBySymbol', 'broker', broker)
            const localVarPath = `/api/v1/instruments/token`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication firebase_jwt required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "firebase_jwt", [], configuration)

            if (symbol !== undefined) {
                localVarQueryParameter['symbol'] = symbol;
            }

            if (broker !== undefined) {
                localVarQueryParameter['broker'] = broker;
            }

            if (exchange !== undefined) {
                localVarQueryParameter['exchange'] = exchange;
            }

            if (expiryDate !== undefined) {
                localVarQueryParameter['expiry_date'] = (expiryDate as any instanceof Date) ?
                    (expiryDate as any).toISOString().substring(0,10) :
                    expiryDate;
            }

            if (strikePrice !== undefined) {
                localVarQueryParameter['strike_price'] = strikePrice;
            }

            if (optionType !== undefined) {
                localVarQueryParameter['option_type'] = optionType;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieve options chain data for a symbol.
         * @summary Get options chain
         * @param {string} symbol 
         * @param {string} expiryDate Expiry date (YYYY-MM-DD)
         * @param {string} [exchange] Exchange (default: NFO). Optional.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        instrumentOptionsChain: async (symbol: string, expiryDate: string, exchange?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'symbol' is not null or undefined
            assertParamExists('instrumentOptionsChain', 'symbol', symbol)
            // verify required parameter 'expiryDate' is not null or undefined
            assertParamExists('instrumentOptionsChain', 'expiryDate', expiryDate)
            const localVarPath = `/api/v1/instruments/options/chain`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication firebase_jwt required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "firebase_jwt", [], configuration)

            if (symbol !== undefined) {
                localVarQueryParameter['symbol'] = symbol;
            }

            if (expiryDate !== undefined) {
                localVarQueryParameter['expiry_date'] = (expiryDate as any instanceof Date) ?
                    (expiryDate as any).toISOString().substring(0,10) :
                    expiryDate;
            }

            if (exchange !== undefined) {
                localVarQueryParameter['exchange'] = exchange;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Search instruments by keyword with exchange filters. When include_mappings=true, each instrument includes broker_mappings (which brokers have this instrument). Default false for performance; use true only in admin/reference UIs.
         * @summary Search instruments
         * @param {string} query Search keyword
         * @param {string} [exchange] Optional exchange filter
         * @param {string} [segment] Optional segment filter
         * @param {string} [sector] Optional sector filter
         * @param {string} [instrumentType] Optional instrument type filter
         * @param {boolean} [isActive] Filter by active status
         * @param {number} [limit] Maximum search results
         * @param {number} [offset] Pagination offset
         * @param {boolean} [includeMappings] Include broker_mappings per instrument (which brokers have it). Use only in admin/reference UIs; keep false for instrument sidebar for performance.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        instrumentSearch: async (query: string, exchange?: string, segment?: string, sector?: string, instrumentType?: string, isActive?: boolean, limit?: number, offset?: number, includeMappings?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'query' is not null or undefined
            assertParamExists('instrumentSearch', 'query', query)
            const localVarPath = `/api/v1/instruments/search`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication firebase_jwt required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "firebase_jwt", [], configuration)

            if (query !== undefined) {
                localVarQueryParameter['query'] = query;
            }

            if (exchange !== undefined) {
                localVarQueryParameter['exchange'] = exchange;
            }

            if (segment !== undefined) {
                localVarQueryParameter['segment'] = segment;
            }

            if (sector !== undefined) {
                localVarQueryParameter['sector'] = sector;
            }

            if (instrumentType !== undefined) {
                localVarQueryParameter['instrument_type'] = instrumentType;
            }

            if (isActive !== undefined) {
                localVarQueryParameter['is_active'] = isActive;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (includeMappings !== undefined) {
                localVarQueryParameter['include_mappings'] = includeMappings;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Resolve a broker-specific token or symbol to a platform instrument.
         * @summary Resolve broker token
         * @param {string} broker Broker identifier
         * @param {string} token Broker token/symbol
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        instrumentTokenResolve: async (broker: string, token: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'broker' is not null or undefined
            assertParamExists('instrumentTokenResolve', 'broker', broker)
            // verify required parameter 'token' is not null or undefined
            assertParamExists('instrumentTokenResolve', 'token', token)
            const localVarPath = `/api/v1/instruments/resolve`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication firebase_jwt required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "firebase_jwt", [], configuration)

            if (broker !== undefined) {
                localVarQueryParameter['broker'] = broker;
            }

            if (token !== undefined) {
                localVarQueryParameter['token'] = token;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Resolve multiple broker tokens to platform instruments.
         * @summary Batch resolve broker tokens
         * @param {InstrumentTokenResolveBatchRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        instrumentTokenResolveBatch: async (body: InstrumentTokenResolveBatchRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'body' is not null or undefined
            assertParamExists('instrumentTokenResolveBatch', 'body', body)
            const localVarPath = `/api/v1/instruments/resolve/batch`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication firebase_jwt required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "firebase_jwt", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary List users
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [email] Filter by email (partial match)
         * @param {ListUsersStatusEnum} [status] 
         * @param {ListUsersRoleEnum} [role] Filter by role
         * @param {boolean} [isActive] Filter by active status
         * @param {string} [categoryId] Filter by category ID
         * @param {string} [sortBy] 
         * @param {ListUsersSortOrderEnum} [sortOrder] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listUsers: async (page?: number, size?: number, email?: string, status?: ListUsersStatusEnum, role?: ListUsersRoleEnum, isActive?: boolean, categoryId?: string, sortBy?: string, sortOrder?: ListUsersSortOrderEnum, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/users`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication firebase_jwt required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "firebase_jwt", [], configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (email !== undefined) {
                localVarQueryParameter['email'] = email;
            }

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }

            if (role !== undefined) {
                localVarQueryParameter['role'] = role;
            }

            if (isActive !== undefined) {
                localVarQueryParameter['is_active'] = isActive;
            }

            if (categoryId !== undefined) {
                localVarQueryParameter['category_id'] = categoryId;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sort_by'] = sortBy;
            }

            if (sortOrder !== undefined) {
                localVarQueryParameter['sort_order'] = sortOrder;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Place multiple orders simultaneously with concurrency control. Supports SIMPLE orders only (market, limit, stop, stop_limit).
         * @summary Place batch orders
         * @param {OrdersBatchRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ordersBatch: async (body: OrdersBatchRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'body' is not null or undefined
            assertParamExists('ordersBatch', 'body', body)
            const localVarPath = `/api/v1/orders/batch`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication firebase_jwt required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "firebase_jwt", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Cancel an existing order and return its final state.
         * @summary Cancel order
         * @param {string} platformOrderId Platform order identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ordersCancel: async (platformOrderId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'platformOrderId' is not null or undefined
            assertParamExists('ordersCancel', 'platformOrderId', platformOrderId)
            const localVarPath = `/api/v1/orders/{platform_order_id}`
                .replace(`{${"platform_order_id"}}`, encodeURIComponent(String(platformOrderId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication firebase_jwt required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "firebase_jwt", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Create a new order and place it with the configured broker. Supports market, limit, stop, trailing stop, iceberg and multi-leg strategies.
         * @summary Create order
         * @param {OrdersCreateRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ordersCreate: async (body: OrdersCreateRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'body' is not null or undefined
            assertParamExists('ordersCreate', 'body', body)
            const localVarPath = `/api/v1/orders`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication firebase_jwt required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "firebase_jwt", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Fetch a single order with broker sync details and fills.
         * @summary Get order
         * @param {string} platformOrderId Platform order identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ordersGet: async (platformOrderId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'platformOrderId' is not null or undefined
            assertParamExists('ordersGet', 'platformOrderId', platformOrderId)
            const localVarPath = `/api/v1/orders/{platform_order_id}`
                .replace(`{${"platform_order_id"}}`, encodeURIComponent(String(platformOrderId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication firebase_jwt required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "firebase_jwt", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * List orders for the authenticated user with filtering and pagination.
         * @summary List orders
         * @param {string} [status] Filter by order status
         * @param {string} [instrumentId] Filter by instrument identifier
         * @param {number} [limit] Number of records to return
         * @param {number} [offset] Pagination offset
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ordersList: async (status?: string, instrumentId?: string, limit?: number, offset?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/orders`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication firebase_jwt required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "firebase_jwt", [], configuration)

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }

            if (instrumentId !== undefined) {
                localVarQueryParameter['instrument_id'] = instrumentId;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Modify an existing order. Only orders in PENDING or PLACED status can be modified. Only certain fields can be updated (quantity, price, stop_price, limit_price, notes).
         * @summary Modify order
         * @param {string} platformOrderId Platform order identifier
         * @param {OrdersModifyRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ordersModify: async (platformOrderId: string, body: OrdersModifyRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'platformOrderId' is not null or undefined
            assertParamExists('ordersModify', 'platformOrderId', platformOrderId)
            // verify required parameter 'body' is not null or undefined
            assertParamExists('ordersModify', 'body', body)
            const localVarPath = `/api/v1/orders/{platform_order_id}`
                .replace(`{${"platform_order_id"}}`, encodeURIComponent(String(platformOrderId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication firebase_jwt required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "firebase_jwt", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Manually trigger synchronization of order details from broker and update the broker_orders table.
         * @summary Sync order from broker
         * @param {string} platformOrderId Platform order identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ordersSync: async (platformOrderId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'platformOrderId' is not null or undefined
            assertParamExists('ordersSync', 'platformOrderId', platformOrderId)
            const localVarPath = `/api/v1/orders/{platform_order_id}/sync`
                .replace(`{${"platform_order_id"}}`, encodeURIComponent(String(platformOrderId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication firebase_jwt required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "firebase_jwt", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get chronological timeline of all events for an order, combining data from platform_orders, order_status_log, order_fills, and broker_orders.
         * @summary Get order timeline
         * @param {string} platformOrderId Platform order identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ordersTimeline: async (platformOrderId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'platformOrderId' is not null or undefined
            assertParamExists('ordersTimeline', 'platformOrderId', platformOrderId)
            const localVarPath = `/api/v1/orders/{platform_order_id}/timeline`
                .replace(`{${"platform_order_id"}}`, encodeURIComponent(String(platformOrderId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication firebase_jwt required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "firebase_jwt", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Delete all portfolio data (holdings and transactions) for a broker account. This endpoint is called automatically when a broker account is deregistered/deleted. It removes all associated portfolio data including holdings and transactions. **Security**: Deletion requires BOTH firebase_uid (from authenticated user) AND broker_account_id to match, ensuring data belongs to the user before deletion.
         * @summary Delete portfolio data for broker account
         * @param {string} brokerAccountId Broker account identifier (String, matches broker_accounts.accounts.broker_account_id)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        portfolioAccountDelete: async (brokerAccountId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'brokerAccountId' is not null or undefined
            assertParamExists('portfolioAccountDelete', 'brokerAccountId', brokerAccountId)
            const localVarPath = `/api/v1/portfolio/account/{broker_account_id}`
                .replace(`{${"broker_account_id"}}`, encodeURIComponent(String(brokerAccountId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication firebase_jwt required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "firebase_jwt", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Return aggregated portfolio snapshot, broker account summaries, and top holdings for the authenticated user.
         * @summary Get consolidated portfolio
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        portfolioGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/portfolio`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication firebase_jwt required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "firebase_jwt", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get a specific holding for the authenticated user.
         * @summary Get holding
         * @param {string} holdingId Holding identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        portfolioHoldingGet: async (holdingId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'holdingId' is not null or undefined
            assertParamExists('portfolioHoldingGet', 'holdingId', holdingId)
            const localVarPath = `/api/v1/holdings/{holding_id}`
                .replace(`{${"holding_id"}}`, encodeURIComponent(String(holdingId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication firebase_jwt required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "firebase_jwt", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Return holdings for the authenticated user with optional broker and symbol filters.
         * @summary List holdings
         * @param {string} [brokerAccountId] Filter holdings by broker account
         * @param {string} [symbol] Filter by instrument symbol
         * @param {string} [exchange] Filter by exchange
         * @param {string} [productType] Filter by product type
         * @param {boolean} [includeClosed] Include closed positions
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        portfolioHoldingsList: async (brokerAccountId?: string, symbol?: string, exchange?: string, productType?: string, includeClosed?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/holdings`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication firebase_jwt required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "firebase_jwt", [], configuration)

            if (brokerAccountId !== undefined) {
                localVarQueryParameter['broker_account_id'] = brokerAccountId;
            }

            if (symbol !== undefined) {
                localVarQueryParameter['symbol'] = symbol;
            }

            if (exchange !== undefined) {
                localVarQueryParameter['exchange'] = exchange;
            }

            if (productType !== undefined) {
                localVarQueryParameter['product_type'] = productType;
            }

            if (includeClosed !== undefined) {
                localVarQueryParameter['include_closed'] = includeClosed;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Manual portfolio sync. When broker_account_id is omitted, syncs all connected broker accounts for the user. When broker_account_id is provided, syncs only that account. 
         * @summary Trigger portfolio sync
         * @param {PortfolioSyncRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        portfolioSync: async (body: PortfolioSyncRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'body' is not null or undefined
            assertParamExists('portfolioSync', 'body', body)
            const localVarPath = `/api/v1/portfolio/sync`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication firebase_jwt required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "firebase_jwt", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Return historical sync operations for a broker account.
         * @summary Get sync history
         * @param {string} brokerAccountId Broker account identifier
         * @param {number} [limit] Maximum sync logs to return
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        portfolioSyncHistory: async (brokerAccountId: string, limit?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'brokerAccountId' is not null or undefined
            assertParamExists('portfolioSyncHistory', 'brokerAccountId', brokerAccountId)
            const localVarPath = `/api/v1/sync/history`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication firebase_jwt required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "firebase_jwt", [], configuration)

            if (brokerAccountId !== undefined) {
                localVarQueryParameter['broker_account_id'] = brokerAccountId;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Return recent sync operations for a broker account.
         * @summary Get recent sync status
         * @param {string} brokerAccountId Broker account identifier
         * @param {number} [limit] Maximum sync logs to return
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        portfolioSyncStatus: async (brokerAccountId: string, limit?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'brokerAccountId' is not null or undefined
            assertParamExists('portfolioSyncStatus', 'brokerAccountId', brokerAccountId)
            const localVarPath = `/api/v1/sync/status`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication firebase_jwt required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "firebase_jwt", [], configuration)

            if (brokerAccountId !== undefined) {
                localVarQueryParameter['broker_account_id'] = brokerAccountId;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieve an individual transaction.
         * @summary Get transaction
         * @param {string} transactionId Transaction identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        portfolioTransactionGet: async (transactionId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'transactionId' is not null or undefined
            assertParamExists('portfolioTransactionGet', 'transactionId', transactionId)
            const localVarPath = `/api/v1/transactions/{transaction_id}`
                .replace(`{${"transaction_id"}}`, encodeURIComponent(String(transactionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication firebase_jwt required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "firebase_jwt", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Return transaction history with pagination and optional filters.
         * @summary List transactions
         * @param {string} [brokerAccountId] Filter by broker account
         * @param {string} [transactionType] Filter by type (buy/sell)
         * @param {string} [symbol] 
         * @param {string} [exchange] 
         * @param {string} [fromDate] 
         * @param {string} [toDate] 
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        portfolioTransactionsList: async (brokerAccountId?: string, transactionType?: string, symbol?: string, exchange?: string, fromDate?: string, toDate?: string, limit?: number, offset?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/transactions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication firebase_jwt required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "firebase_jwt", [], configuration)

            if (brokerAccountId !== undefined) {
                localVarQueryParameter['broker_account_id'] = brokerAccountId;
            }

            if (transactionType !== undefined) {
                localVarQueryParameter['transaction_type'] = transactionType;
            }

            if (symbol !== undefined) {
                localVarQueryParameter['symbol'] = symbol;
            }

            if (exchange !== undefined) {
                localVarQueryParameter['exchange'] = exchange;
            }

            if (fromDate !== undefined) {
                localVarQueryParameter['from_date'] = (fromDate as any instanceof Date) ?
                    (fromDate as any).toISOString().substring(0,10) :
                    fromDate;
            }

            if (toDate !== undefined) {
                localVarQueryParameter['to_date'] = (toDate as any instanceof Date) ?
                    (toDate as any).toISOString().substring(0,10) :
                    toDate;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Remove watchlist item by item ID
         * @param {string} groupId 
         * @param {string} itemId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeWatchlistItem: async (groupId: string, itemId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'groupId' is not null or undefined
            assertParamExists('removeWatchlistItem', 'groupId', groupId)
            // verify required parameter 'itemId' is not null or undefined
            assertParamExists('removeWatchlistItem', 'itemId', itemId)
            const localVarPath = `/api/v1/users/me/watchlist/groups/{group_id}/items/{item_id}`
                .replace(`{${"group_id"}}`, encodeURIComponent(String(groupId)))
                .replace(`{${"item_id"}}`, encodeURIComponent(String(itemId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication firebase_jwt required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "firebase_jwt", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Remove instrument from watchlist group by instrument ID
         * @param {string} userId 
         * @param {string} groupId 
         * @param {string} instrumentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeWatchlistItemByInstrument: async (userId: string, groupId: string, instrumentId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('removeWatchlistItemByInstrument', 'userId', userId)
            // verify required parameter 'groupId' is not null or undefined
            assertParamExists('removeWatchlistItemByInstrument', 'groupId', groupId)
            // verify required parameter 'instrumentId' is not null or undefined
            assertParamExists('removeWatchlistItemByInstrument', 'instrumentId', instrumentId)
            const localVarPath = `/api/v1/users/me/watchlist/groups/{group_id}/items/instrument/{instrument_id}`
                .replace(`{${"user_id"}}`, encodeURIComponent(String(userId)))
                .replace(`{${"group_id"}}`, encodeURIComponent(String(groupId)))
                .replace(`{${"instrument_id"}}`, encodeURIComponent(String(instrumentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication firebase_jwt required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "firebase_jwt", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Set preference
         * @param {string} userId 
         * @param {string} key 
         * @param {SetUserPreferenceRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setUserPreference: async (userId: string, key: string, body: SetUserPreferenceRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('setUserPreference', 'userId', userId)
            // verify required parameter 'key' is not null or undefined
            assertParamExists('setUserPreference', 'key', key)
            // verify required parameter 'body' is not null or undefined
            assertParamExists('setUserPreference', 'body', body)
            const localVarPath = `/api/v1/users/{user_id}/preferences/{key}`
                .replace(`{${"user_id"}}`, encodeURIComponent(String(userId)))
                .replace(`{${"key"}}`, encodeURIComponent(String(key)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication firebase_jwt required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "firebase_jwt", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Activate or deactivate a supported broker. Admin only.
         * @summary Update broker status
         * @param {string} brokerType 
         * @param {UpdateBrokerStatusRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateBrokerStatus: async (brokerType: string, body: UpdateBrokerStatusRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'brokerType' is not null or undefined
            assertParamExists('updateBrokerStatus', 'brokerType', brokerType)
            // verify required parameter 'body' is not null or undefined
            assertParamExists('updateBrokerStatus', 'body', body)
            const localVarPath = `/api/v1/broker-accounts/supported-brokers/{broker_type}/status`
                .replace(`{${"broker_type"}}`, encodeURIComponent(String(brokerType)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication firebase_jwt required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "firebase_jwt", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update current user\'s profile
         * @param {UpdateCurrentUserProfileRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCurrentUserProfile: async (body: UpdateCurrentUserProfileRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'body' is not null or undefined
            assertParamExists('updateCurrentUserProfile', 'body', body)
            const localVarPath = `/api/v1/users/me/profile`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication firebase_jwt required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "firebase_jwt", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update user
         * @param {string} userId 
         * @param {object} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateUser: async (userId: string, body: object, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('updateUser', 'userId', userId)
            // verify required parameter 'body' is not null or undefined
            assertParamExists('updateUser', 'body', body)
            const localVarPath = `/api/v1/users/{user_id}`
                .replace(`{${"user_id"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication firebase_jwt required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "firebase_jwt", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update an existing user category (admin only).
         * @summary Update user category
         * @param {string} categoryId 
         * @param {UpdateUserCategoryRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateUserCategory: async (categoryId: string, body: UpdateUserCategoryRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'categoryId' is not null or undefined
            assertParamExists('updateUserCategory', 'categoryId', categoryId)
            // verify required parameter 'body' is not null or undefined
            assertParamExists('updateUserCategory', 'body', body)
            const localVarPath = `/api/v1/users/categories/{category_id}`
                .replace(`{${"category_id"}}`, encodeURIComponent(String(categoryId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication firebase_jwt required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "firebase_jwt", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update user profile by user ID or Firebase UID
         * @param {string} userId User ID (UUID) or Firebase UID. If Firebase UID is provided, user will be looked up first.
         * @param {UpdateCurrentUserProfileRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateUserProfile: async (userId: string, body: UpdateCurrentUserProfileRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('updateUserProfile', 'userId', userId)
            // verify required parameter 'body' is not null or undefined
            assertParamExists('updateUserProfile', 'body', body)
            const localVarPath = `/api/v1/users/{user_id}/profile`
                .replace(`{${"user_id"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication firebase_jwt required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "firebase_jwt", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update watchlist group
         * @param {string} groupId 
         * @param {UpdateWatchlistGroupRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateWatchlistGroup: async (groupId: string, body: UpdateWatchlistGroupRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'groupId' is not null or undefined
            assertParamExists('updateWatchlistGroup', 'groupId', groupId)
            // verify required parameter 'body' is not null or undefined
            assertParamExists('updateWatchlistGroup', 'body', body)
            const localVarPath = `/api/v1/users/me/watchlist/groups/{group_id}`
                .replace(`{${"group_id"}}`, encodeURIComponent(String(groupId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication firebase_jwt required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "firebase_jwt", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update watchlist item
         * @param {string} groupId 
         * @param {string} itemId 
         * @param {UpdateWatchlistItemRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateWatchlistItem: async (groupId: string, itemId: string, body: UpdateWatchlistItemRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'groupId' is not null or undefined
            assertParamExists('updateWatchlistItem', 'groupId', groupId)
            // verify required parameter 'itemId' is not null or undefined
            assertParamExists('updateWatchlistItem', 'itemId', itemId)
            // verify required parameter 'body' is not null or undefined
            assertParamExists('updateWatchlistItem', 'body', body)
            const localVarPath = `/api/v1/users/me/watchlist/groups/{group_id}/items/{item_id}`
                .replace(`{${"group_id"}}`, encodeURIComponent(String(groupId)))
                .replace(`{${"item_id"}}`, encodeURIComponent(String(itemId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication firebase_jwt required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "firebase_jwt", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DefaultApi - functional programming interface
 */
export const DefaultApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DefaultApiAxiosParamCreator(configuration)
    return {
        /**
         * Registers a new supported broker. Admin only.
         * @summary Add a supported broker
         * @param {AddSupportedBrokerRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addSupportedBroker(body: AddSupportedBrokerRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BrokerMetadataResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addSupportedBroker(body, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.addSupportedBroker']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Add instrument to watchlist group
         * @param {string} groupId 
         * @param {AddWatchlistItemRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addWatchlistItem(groupId: string, body: AddWatchlistItemRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AddWatchlistItem201Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addWatchlistItem(groupId, body, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.addWatchlistItem']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Send AG-UI RunAgentInput request and stream AG-UI protocol events (SSE or JSON-lines format). Uses AG-UI protocol libraries for request/response handling.
         * @summary AG-UI protocol endpoint - stream agent responses
         * @param {AiAssistAguiStreamRequest} body AG-UI RunAgentInput request (from @ag-ui/core library)
         * @param {string} [accept] Response format: \&#39;text/event-stream\&#39; (SSE) or \&#39;application/x-ndjson\&#39; (JSON-lines)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async aiAssistAguiStream(body: AiAssistAguiStreamRequest, accept?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AiAssistAguiStream200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.aiAssistAguiStream(body, accept, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.aiAssistAguiStream']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Delete a session from Vertex AI Agent Engine. This permanently removes the session and all its associated messages.
         * @summary Delete an ADK session
         * @param {string} sessionId ADK session ID to delete
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async aiAssistSessionDelete(sessionId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AiAssistSessionDelete200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.aiAssistSessionDelete(sessionId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.aiAssistSessionDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieve all messages (events) associated with a specific session from Vertex AI Agent Engine. The messages are returned in chronological order.
         * @summary Get message history for a specific ADK session
         * @param {string} sessionId ADK session ID to retrieve messages for
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async aiAssistSessionMessagesGet(sessionId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetSessionMessagesResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.aiAssistSessionMessagesGet(sessionId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.aiAssistSessionMessagesGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Update the display name for a session. The session_id itself cannot be changed, but a custom display name can be stored and displayed in the UI.
         * @summary Update session display name
         * @param {string} sessionId ADK session ID to update
         * @param {UpdateSessionDisplayNameRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async aiAssistSessionUpdate(sessionId: string, body: UpdateSessionDisplayNameRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AiAssistSessionUpdate200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.aiAssistSessionUpdate(sessionId, body, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.aiAssistSessionUpdate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Create a new ADK session in Vertex AI Agent Engine. The returned session_id should be used in all subsequent AG-UI requests (via threadId field) to maintain conversation continuity across multiple user messages.
         * @summary Create ADK session for conversation continuity
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async aiAssistSessionsCreate(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CreateSessionResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.aiAssistSessionsCreate(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.aiAssistSessionsCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieve all sessions associated with the authenticated user from Vertex AI Agent Engine. Sessions are returned as a list of session IDs that can be used for conversation continuity.
         * @summary List all ADK sessions for the authenticated user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async aiAssistSessionsList(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListSessionsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.aiAssistSessionsList(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.aiAssistSessionsList']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Disconnect a broker account from the platform.
         * @summary Disconnect broker account
         * @param {BrokerAccountDisconnectRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async brokerAccountDisconnect(body: BrokerAccountDisconnectRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BrokerAccountDisconnect200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.brokerAccountDisconnect(body, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.brokerAccountDisconnect']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieve a single broker account.
         * @summary Get broker account
         * @param {string} accountId Broker account identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async brokerAccountGet(accountId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BrokerAccountResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.brokerAccountGet(accountId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.brokerAccountGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Update broker account preferences.
         * @summary Update broker account
         * @param {string} accountId Broker account identifier
         * @param {BrokerAccountUpdateRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async brokerAccountUpdate(accountId: string, body: BrokerAccountUpdateRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BrokerAccountResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.brokerAccountUpdate(accountId, body, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.brokerAccountUpdate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * List broker accounts linked to the authenticated user.
         * @summary List broker accounts
         * @param {string} [brokerType] Filter by broker type
         * @param {string} [status] Filter by account status
         * @param {boolean} [paperTrading] Filter by paper trading mode
         * @param {number} [limit] Maximum number of results
         * @param {number} [offset] Pagination offset
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async brokerAccountsList(brokerType?: string, status?: string, paperTrading?: boolean, limit?: number, offset?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BrokerAccountListResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.brokerAccountsList(brokerType, status, paperTrading, limit, offset, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.brokerAccountsList']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get list of all supported broker platforms. Public endpoint - no authentication required.
         * @summary Get supported brokers
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async brokerAccountsSupportedBrokers(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SupportedBrokersResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.brokerAccountsSupportedBrokers(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.brokerAccountsSupportedBrokers']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Initiate broker account registration and OAuth flow.
         * @summary Register broker account
         * @param {BrokerRegistrationRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async brokerRegistration(body: BrokerRegistrationRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BrokerRegistrationResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.brokerRegistration(body, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.brokerRegistration']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Handle OAuth callbacks from broker partners. Public endpoint invoked by brokers.
         * @summary Broker OAuth callback
         * @param {string} brokerType Broker identifier
         * @param {string} [state] 
         * @param {string} [oauthState] 
         * @param {string} [code] 
         * @param {string} [requestToken] 
         * @param {string} [action] 
         * @param {string} [status] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async brokerRegistrationCallback(brokerType: string, state?: string, oauthState?: string, code?: string, requestToken?: string, action?: string, status?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.brokerRegistrationCallback(brokerType, state, oauthState, code, requestToken, action, status, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.brokerRegistrationCallback']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Deregister and delete a broker account by registration ID.
         * @summary Deregister broker account
         * @param {string} registrationId Registration identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async brokerRegistrationDeregister(registrationId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BrokerRegistrationDeregister200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.brokerRegistrationDeregister(registrationId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.brokerRegistrationDeregister']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Migrate existing OAuth account to TOTP-based automated authentication. Verifies account ownership and current auth_mode=\'oauth\', validates TOTP secret format, stores credentials in Secret Manager, performs one-time validation login, and updates account to TOTP mode if successful. Existing access token is preserved during migration.
         * @summary Migrate existing OAuth account to TOTP-based automated authentication
         * @param {string} registrationId Registration identifier
         * @param {BrokerRegistrationMigrateToTOTPRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async brokerRegistrationMigrateToTOTP(registrationId: string, body: BrokerRegistrationMigrateToTOTPRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MigrateToTOTPResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.brokerRegistrationMigrateToTOTP(registrationId, body, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.brokerRegistrationMigrateToTOTP']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Reconnect broker account. Routes to automated TOTP login or OAuth flow based on account auth_mode. If auth_mode=\'totp_automated\', performs automated login using stored TOTP credentials. If auth_mode=\'oauth\', returns OAuth URL for manual login.
         * @summary Reconnect broker account
         * @param {BrokerRegistrationReconnectRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async brokerRegistrationReconnect(body: BrokerRegistrationReconnectRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ReconnectResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.brokerRegistrationReconnect(body, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.brokerRegistrationReconnect']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Check the status of a broker registration flow.
         * @summary Get registration status
         * @param {string} registrationId Registration identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async brokerRegistrationStatus(registrationId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ConnectionStatusResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.brokerRegistrationStatus(registrationId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.brokerRegistrationStatus']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Register broker account with TOTP credentials for automated authentication. Supports any broker that implements automated login (e.g., Zerodha, Groww). Stores credentials securely in GCP Secret Manager, creates account record, performs one-time validation login, and returns registration details if successful. If validation fails, credentials are automatically cleaned up.
         * @summary Register broker account with TOTP credentials
         * @param {BrokerRegistrationTOTPRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async brokerRegistrationTOTP(body: BrokerRegistrationTOTPRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RegisterTOTPResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.brokerRegistrationTOTP(body, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.brokerRegistrationTOTP']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Update TOTP credentials for an existing account. Verifies account ownership, validates new credentials format, updates credentials in Secret Manager, performs validation login with new credentials, and updates account metadata if successful. Requires account to be in TOTP mode (auth_mode=\'totp_automated\').
         * @summary Update TOTP credentials for existing account
         * @param {string} registrationId Registration identifier
         * @param {BrokerRegistrationUpdateTOTPCredentialsRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async brokerRegistrationUpdateTOTPCredentials(registrationId: string, body: BrokerRegistrationUpdateTOTPCredentialsRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UpdateCredentialsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.brokerRegistrationUpdateTOTPCredentials(registrationId, body, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.brokerRegistrationUpdateTOTPCredentials']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Updates a user\'s role. Caller must have the \'admin\' role — enforced server-side.
         * @summary Change user role (admin only)
         * @param {string} userId Target user\&#39;s UUID
         * @param {ChangeUserRoleRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async changeUserRole(userId: string, body: ChangeUserRoleRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CreateUser201Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.changeUserRole(userId, body, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.changeUserRole']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Check quota for resource type
         * @param {string} userId 
         * @param {CheckUserQuotaResourceTypeEnum} resourceType 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async checkUserQuota(userId: string, resourceType: CheckUserQuotaResourceTypeEnum, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CheckUserQuota200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.checkUserQuota(userId, resourceType, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.checkUserQuota']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Create user
         * @param {CreateUserRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createUser(body: CreateUserRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CreateUser201Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createUser(body, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.createUser']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Create a new user category (admin only).
         * @summary Create user category
         * @param {CreateUserCategoryRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createUserCategory(body: CreateUserCategoryRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CreateUserCategory201Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createUserCategory(body, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.createUserCategory']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Create watchlist group
         * @param {CreateWatchlistGroupRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createWatchlistGroup(body: CreateWatchlistGroupRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CreateWatchlistGroup201Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createWatchlistGroup(body, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.createWatchlistGroup']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Delete user (soft delete)
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteUser(userId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteUser(userId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.deleteUser']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Delete watchlist group
         * @param {string} groupId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteWatchlistGroup(groupId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DeleteWatchlistGroup200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteWatchlistGroup(groupId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.deleteWatchlistGroup']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Detailed health check
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async detailedHealthCheck(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DetailedHealthCheck200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.detailedHealthCheck(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.detailedHealthCheck']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get all watchlist groups
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllWatchlistGroups(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetAllWatchlistGroups200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllWatchlistGroups(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getAllWatchlistGroups']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get all watchlist items in group
         * @param {string} groupId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllWatchlistItems(groupId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetAllWatchlistItems200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllWatchlistItems(groupId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getAllWatchlistItems']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get current user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCurrentUser(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetCurrentUser200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCurrentUser(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getCurrentUser']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get current user\'s profile
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCurrentUserProfile(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetCurrentUserProfile200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCurrentUserProfile(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getCurrentUserProfile']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieve the instruments that make up a specific index.
         * @summary Get index constituents
         * @param {string} indexSymbol Index symbol (e.g., NIFTY 50)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getIndexConstituents(indexSymbol: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<InstrumentResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getIndexConstituents(indexSymbol, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getIndexConstituents']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieve a list of all available market indices.
         * @summary Get all indices
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getIndices(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GetIndices200ResponseInner>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getIndices(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getIndices']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get user by ID
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getUserById(userId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetUserById200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getUserById(userId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getUserById']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * List all user categories (admin only). Reference data.
         * @summary List user categories
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getUserCategories(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetUserCategories200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getUserCategories(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getUserCategories']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get preference by key
         * @param {string} userId 
         * @param {string} key 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getUserPreference(userId: string, key: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetUserPreference200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getUserPreference(userId, key, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getUserPreference']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get all user preferences
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getUserPreferences(userId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetUserPreferences200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getUserPreferences(userId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getUserPreferences']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get user profile by user ID or Firebase UID
         * @param {string} userId User ID (UUID) or Firebase UID. If Firebase UID is provided, user will be looked up first.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getUserProfile(userId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetCurrentUserProfile200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getUserProfile(userId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getUserProfile']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get user quotas
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getUserQuotas(userId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetUserQuotas200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getUserQuotas(userId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getUserQuotas']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get watchlist group
         * @param {string} groupId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getWatchlistGroup(groupId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetWatchlistGroup200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getWatchlistGroup(groupId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getWatchlistGroup']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get watchlist item
         * @param {string} groupId 
         * @param {string} itemId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getWatchlistItem(groupId: string, itemId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetWatchlistItem200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getWatchlistItem(groupId, itemId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getWatchlistItem']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Basic health check
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async healthCheck(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<HealthCheck200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.healthCheck(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.healthCheck']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Fetch multiple instruments by ID in a single request.
         * @summary Batch fetch instruments
         * @param {InstrumentBatchRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async instrumentBatch(body: InstrumentBatchRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InstrumentListResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.instrumentBatch(body, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.instrumentBatch']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieve futures instruments for a symbol.
         * @summary Get futures instruments
         * @param {string} symbol 
         * @param {string} [exchange] Exchange (default: NFO). Optional.
         * @param {string} [expiryStart] Start of expiry date range (YYYY-MM-DD)
         * @param {string} [expiryEnd] End of expiry date range (YYYY-MM-DD)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async instrumentFutures(symbol: string, exchange?: string, expiryStart?: string, expiryEnd?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<{ [key: string]: any; }>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.instrumentFutures(symbol, exchange, expiryStart, expiryEnd, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.instrumentFutures']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Fetch instrument master data by instrument identifier.
         * @summary Get instrument
         * @param {string} instrumentId Instrument identifier
         * @param {boolean} [includeMappings] Whether to include broker mappings in the response
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async instrumentGet(instrumentId: string, includeMappings?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InstrumentResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.instrumentGet(instrumentId, includeMappings, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.instrumentGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get broker-specific instrument token from symbol and broker type. Reverse operation of token resolution. Used when user selects an instrument symbol and needs the broker-specific token for their broker account.
         * @summary Get broker token by symbol
         * @param {string} symbol Trading symbol (e.g., \&#39;INFY\&#39;)
         * @param {string} broker Broker type (zerodha, upstox, dhan, etc.)
         * @param {string} [exchange] Exchange code (e.g., \&#39;NSE\&#39;, \&#39;BSE\&#39;). Optional, searches all if not provided.
         * @param {string} [expiryDate] Expiry date for derivatives (YYYY-MM-DD)
         * @param {number} [strikePrice] Strike price for options
         * @param {InstrumentGetTokenBySymbolOptionTypeEnum} [optionType] Option type (CE/PE) for options
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async instrumentGetTokenBySymbol(symbol: string, broker: string, exchange?: string, expiryDate?: string, strikePrice?: number, optionType?: InstrumentGetTokenBySymbolOptionTypeEnum, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BrokerTokenResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.instrumentGetTokenBySymbol(symbol, broker, exchange, expiryDate, strikePrice, optionType, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.instrumentGetTokenBySymbol']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieve options chain data for a symbol.
         * @summary Get options chain
         * @param {string} symbol 
         * @param {string} expiryDate Expiry date (YYYY-MM-DD)
         * @param {string} [exchange] Exchange (default: NFO). Optional.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async instrumentOptionsChain(symbol: string, expiryDate: string, exchange?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<{ [key: string]: any; }>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.instrumentOptionsChain(symbol, expiryDate, exchange, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.instrumentOptionsChain']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Search instruments by keyword with exchange filters. When include_mappings=true, each instrument includes broker_mappings (which brokers have this instrument). Default false for performance; use true only in admin/reference UIs.
         * @summary Search instruments
         * @param {string} query Search keyword
         * @param {string} [exchange] Optional exchange filter
         * @param {string} [segment] Optional segment filter
         * @param {string} [sector] Optional sector filter
         * @param {string} [instrumentType] Optional instrument type filter
         * @param {boolean} [isActive] Filter by active status
         * @param {number} [limit] Maximum search results
         * @param {number} [offset] Pagination offset
         * @param {boolean} [includeMappings] Include broker_mappings per instrument (which brokers have it). Use only in admin/reference UIs; keep false for instrument sidebar for performance.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async instrumentSearch(query: string, exchange?: string, segment?: string, sector?: string, instrumentType?: string, isActive?: boolean, limit?: number, offset?: number, includeMappings?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InstrumentListResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.instrumentSearch(query, exchange, segment, sector, instrumentType, isActive, limit, offset, includeMappings, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.instrumentSearch']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Resolve a broker-specific token or symbol to a platform instrument.
         * @summary Resolve broker token
         * @param {string} broker Broker identifier
         * @param {string} token Broker token/symbol
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async instrumentTokenResolve(broker: string, token: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TokenResolutionResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.instrumentTokenResolve(broker, token, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.instrumentTokenResolve']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Resolve multiple broker tokens to platform instruments.
         * @summary Batch resolve broker tokens
         * @param {InstrumentTokenResolveBatchRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async instrumentTokenResolveBatch(body: InstrumentTokenResolveBatchRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InstrumentTokenResolveBatch200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.instrumentTokenResolveBatch(body, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.instrumentTokenResolveBatch']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary List users
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [email] Filter by email (partial match)
         * @param {ListUsersStatusEnum} [status] 
         * @param {ListUsersRoleEnum} [role] Filter by role
         * @param {boolean} [isActive] Filter by active status
         * @param {string} [categoryId] Filter by category ID
         * @param {string} [sortBy] 
         * @param {ListUsersSortOrderEnum} [sortOrder] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listUsers(page?: number, size?: number, email?: string, status?: ListUsersStatusEnum, role?: ListUsersRoleEnum, isActive?: boolean, categoryId?: string, sortBy?: string, sortOrder?: ListUsersSortOrderEnum, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListUsers200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listUsers(page, size, email, status, role, isActive, categoryId, sortBy, sortOrder, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.listUsers']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Place multiple orders simultaneously with concurrency control. Supports SIMPLE orders only (market, limit, stop, stop_limit).
         * @summary Place batch orders
         * @param {OrdersBatchRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async ordersBatch(body: OrdersBatchRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OrdersBatch200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.ordersBatch(body, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.ordersBatch']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Cancel an existing order and return its final state.
         * @summary Cancel order
         * @param {string} platformOrderId Platform order identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async ordersCancel(platformOrderId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OrderResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.ordersCancel(platformOrderId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.ordersCancel']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Create a new order and place it with the configured broker. Supports market, limit, stop, trailing stop, iceberg and multi-leg strategies.
         * @summary Create order
         * @param {OrdersCreateRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async ordersCreate(body: OrdersCreateRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OrderResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.ordersCreate(body, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.ordersCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Fetch a single order with broker sync details and fills.
         * @summary Get order
         * @param {string} platformOrderId Platform order identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async ordersGet(platformOrderId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OrderResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.ordersGet(platformOrderId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.ordersGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * List orders for the authenticated user with filtering and pagination.
         * @summary List orders
         * @param {string} [status] Filter by order status
         * @param {string} [instrumentId] Filter by instrument identifier
         * @param {number} [limit] Number of records to return
         * @param {number} [offset] Pagination offset
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async ordersList(status?: string, instrumentId?: string, limit?: number, offset?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OrdersList200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.ordersList(status, instrumentId, limit, offset, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.ordersList']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Modify an existing order. Only orders in PENDING or PLACED status can be modified. Only certain fields can be updated (quantity, price, stop_price, limit_price, notes).
         * @summary Modify order
         * @param {string} platformOrderId Platform order identifier
         * @param {OrdersModifyRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async ordersModify(platformOrderId: string, body: OrdersModifyRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OrderResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.ordersModify(platformOrderId, body, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.ordersModify']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Manually trigger synchronization of order details from broker and update the broker_orders table.
         * @summary Sync order from broker
         * @param {string} platformOrderId Platform order identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async ordersSync(platformOrderId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OrderResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.ordersSync(platformOrderId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.ordersSync']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get chronological timeline of all events for an order, combining data from platform_orders, order_status_log, order_fills, and broker_orders.
         * @summary Get order timeline
         * @param {string} platformOrderId Platform order identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async ordersTimeline(platformOrderId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OrdersTimeline200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.ordersTimeline(platformOrderId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.ordersTimeline']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Delete all portfolio data (holdings and transactions) for a broker account. This endpoint is called automatically when a broker account is deregistered/deleted. It removes all associated portfolio data including holdings and transactions. **Security**: Deletion requires BOTH firebase_uid (from authenticated user) AND broker_account_id to match, ensuring data belongs to the user before deletion.
         * @summary Delete portfolio data for broker account
         * @param {string} brokerAccountId Broker account identifier (String, matches broker_accounts.accounts.broker_account_id)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async portfolioAccountDelete(brokerAccountId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PortfolioAccountDelete200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.portfolioAccountDelete(brokerAccountId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.portfolioAccountDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Return aggregated portfolio snapshot, broker account summaries, and top holdings for the authenticated user.
         * @summary Get consolidated portfolio
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async portfolioGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PortfolioGet200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.portfolioGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.portfolioGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get a specific holding for the authenticated user.
         * @summary Get holding
         * @param {string} holdingId Holding identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async portfolioHoldingGet(holdingId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<HoldingResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.portfolioHoldingGet(holdingId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.portfolioHoldingGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Return holdings for the authenticated user with optional broker and symbol filters.
         * @summary List holdings
         * @param {string} [brokerAccountId] Filter holdings by broker account
         * @param {string} [symbol] Filter by instrument symbol
         * @param {string} [exchange] Filter by exchange
         * @param {string} [productType] Filter by product type
         * @param {boolean} [includeClosed] Include closed positions
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async portfolioHoldingsList(brokerAccountId?: string, symbol?: string, exchange?: string, productType?: string, includeClosed?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PortfolioHoldingsList200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.portfolioHoldingsList(brokerAccountId, symbol, exchange, productType, includeClosed, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.portfolioHoldingsList']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Manual portfolio sync. When broker_account_id is omitted, syncs all connected broker accounts for the user. When broker_account_id is provided, syncs only that account. 
         * @summary Trigger portfolio sync
         * @param {PortfolioSyncRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async portfolioSync(body: PortfolioSyncRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PortfolioSync200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.portfolioSync(body, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.portfolioSync']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Return historical sync operations for a broker account.
         * @summary Get sync history
         * @param {string} brokerAccountId Broker account identifier
         * @param {number} [limit] Maximum sync logs to return
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async portfolioSyncHistory(brokerAccountId: string, limit?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<{ [key: string]: any; }>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.portfolioSyncHistory(brokerAccountId, limit, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.portfolioSyncHistory']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Return recent sync operations for a broker account.
         * @summary Get recent sync status
         * @param {string} brokerAccountId Broker account identifier
         * @param {number} [limit] Maximum sync logs to return
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async portfolioSyncStatus(brokerAccountId: string, limit?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<{ [key: string]: any; }>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.portfolioSyncStatus(brokerAccountId, limit, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.portfolioSyncStatus']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieve an individual transaction.
         * @summary Get transaction
         * @param {string} transactionId Transaction identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async portfolioTransactionGet(transactionId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TransactionResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.portfolioTransactionGet(transactionId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.portfolioTransactionGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Return transaction history with pagination and optional filters.
         * @summary List transactions
         * @param {string} [brokerAccountId] Filter by broker account
         * @param {string} [transactionType] Filter by type (buy/sell)
         * @param {string} [symbol] 
         * @param {string} [exchange] 
         * @param {string} [fromDate] 
         * @param {string} [toDate] 
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async portfolioTransactionsList(brokerAccountId?: string, transactionType?: string, symbol?: string, exchange?: string, fromDate?: string, toDate?: string, limit?: number, offset?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PortfolioTransactionsList200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.portfolioTransactionsList(brokerAccountId, transactionType, symbol, exchange, fromDate, toDate, limit, offset, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.portfolioTransactionsList']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Remove watchlist item by item ID
         * @param {string} groupId 
         * @param {string} itemId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async removeWatchlistItem(groupId: string, itemId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DeleteWatchlistGroup200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.removeWatchlistItem(groupId, itemId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.removeWatchlistItem']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Remove instrument from watchlist group by instrument ID
         * @param {string} userId 
         * @param {string} groupId 
         * @param {string} instrumentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async removeWatchlistItemByInstrument(userId: string, groupId: string, instrumentId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DeleteWatchlistGroup200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.removeWatchlistItemByInstrument(userId, groupId, instrumentId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.removeWatchlistItemByInstrument']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Set preference
         * @param {string} userId 
         * @param {string} key 
         * @param {SetUserPreferenceRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async setUserPreference(userId: string, key: string, body: SetUserPreferenceRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.setUserPreference(userId, key, body, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.setUserPreference']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Activate or deactivate a supported broker. Admin only.
         * @summary Update broker status
         * @param {string} brokerType 
         * @param {UpdateBrokerStatusRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateBrokerStatus(brokerType: string, body: UpdateBrokerStatusRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BrokerMetadataResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateBrokerStatus(brokerType, body, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.updateBrokerStatus']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update current user\'s profile
         * @param {UpdateCurrentUserProfileRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateCurrentUserProfile(body: UpdateCurrentUserProfileRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CreateUser201Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateCurrentUserProfile(body, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.updateCurrentUserProfile']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update user
         * @param {string} userId 
         * @param {object} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateUser(userId: string, body: object, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateUser(userId, body, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.updateUser']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Update an existing user category (admin only).
         * @summary Update user category
         * @param {string} categoryId 
         * @param {UpdateUserCategoryRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateUserCategory(categoryId: string, body: UpdateUserCategoryRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CreateUserCategory201Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateUserCategory(categoryId, body, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.updateUserCategory']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update user profile by user ID or Firebase UID
         * @param {string} userId User ID (UUID) or Firebase UID. If Firebase UID is provided, user will be looked up first.
         * @param {UpdateCurrentUserProfileRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateUserProfile(userId: string, body: UpdateCurrentUserProfileRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CreateUser201Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateUserProfile(userId, body, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.updateUserProfile']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update watchlist group
         * @param {string} groupId 
         * @param {UpdateWatchlistGroupRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateWatchlistGroup(groupId: string, body: UpdateWatchlistGroupRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CreateWatchlistGroup201Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateWatchlistGroup(groupId, body, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.updateWatchlistGroup']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update watchlist item
         * @param {string} groupId 
         * @param {string} itemId 
         * @param {UpdateWatchlistItemRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateWatchlistItem(groupId: string, itemId: string, body: UpdateWatchlistItemRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AddWatchlistItem201Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateWatchlistItem(groupId, itemId, body, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.updateWatchlistItem']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * DefaultApi - factory interface
 */
export const DefaultApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DefaultApiFp(configuration)
    return {
        /**
         * Registers a new supported broker. Admin only.
         * @summary Add a supported broker
         * @param {AddSupportedBrokerRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addSupportedBroker(body: AddSupportedBrokerRequest, options?: RawAxiosRequestConfig): AxiosPromise<BrokerMetadataResponse> {
            return localVarFp.addSupportedBroker(body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Add instrument to watchlist group
         * @param {string} groupId 
         * @param {AddWatchlistItemRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addWatchlistItem(groupId: string, body: AddWatchlistItemRequest, options?: RawAxiosRequestConfig): AxiosPromise<AddWatchlistItem201Response> {
            return localVarFp.addWatchlistItem(groupId, body, options).then((request) => request(axios, basePath));
        },
        /**
         * Send AG-UI RunAgentInput request and stream AG-UI protocol events (SSE or JSON-lines format). Uses AG-UI protocol libraries for request/response handling.
         * @summary AG-UI protocol endpoint - stream agent responses
         * @param {AiAssistAguiStreamRequest} body AG-UI RunAgentInput request (from @ag-ui/core library)
         * @param {string} [accept] Response format: \&#39;text/event-stream\&#39; (SSE) or \&#39;application/x-ndjson\&#39; (JSON-lines)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        aiAssistAguiStream(body: AiAssistAguiStreamRequest, accept?: string, options?: RawAxiosRequestConfig): AxiosPromise<AiAssistAguiStream200Response> {
            return localVarFp.aiAssistAguiStream(body, accept, options).then((request) => request(axios, basePath));
        },
        /**
         * Delete a session from Vertex AI Agent Engine. This permanently removes the session and all its associated messages.
         * @summary Delete an ADK session
         * @param {string} sessionId ADK session ID to delete
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        aiAssistSessionDelete(sessionId: string, options?: RawAxiosRequestConfig): AxiosPromise<AiAssistSessionDelete200Response> {
            return localVarFp.aiAssistSessionDelete(sessionId, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieve all messages (events) associated with a specific session from Vertex AI Agent Engine. The messages are returned in chronological order.
         * @summary Get message history for a specific ADK session
         * @param {string} sessionId ADK session ID to retrieve messages for
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        aiAssistSessionMessagesGet(sessionId: string, options?: RawAxiosRequestConfig): AxiosPromise<GetSessionMessagesResponse> {
            return localVarFp.aiAssistSessionMessagesGet(sessionId, options).then((request) => request(axios, basePath));
        },
        /**
         * Update the display name for a session. The session_id itself cannot be changed, but a custom display name can be stored and displayed in the UI.
         * @summary Update session display name
         * @param {string} sessionId ADK session ID to update
         * @param {UpdateSessionDisplayNameRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        aiAssistSessionUpdate(sessionId: string, body: UpdateSessionDisplayNameRequest, options?: RawAxiosRequestConfig): AxiosPromise<AiAssistSessionUpdate200Response> {
            return localVarFp.aiAssistSessionUpdate(sessionId, body, options).then((request) => request(axios, basePath));
        },
        /**
         * Create a new ADK session in Vertex AI Agent Engine. The returned session_id should be used in all subsequent AG-UI requests (via threadId field) to maintain conversation continuity across multiple user messages.
         * @summary Create ADK session for conversation continuity
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        aiAssistSessionsCreate(options?: RawAxiosRequestConfig): AxiosPromise<CreateSessionResponse> {
            return localVarFp.aiAssistSessionsCreate(options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieve all sessions associated with the authenticated user from Vertex AI Agent Engine. Sessions are returned as a list of session IDs that can be used for conversation continuity.
         * @summary List all ADK sessions for the authenticated user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        aiAssistSessionsList(options?: RawAxiosRequestConfig): AxiosPromise<ListSessionsResponse> {
            return localVarFp.aiAssistSessionsList(options).then((request) => request(axios, basePath));
        },
        /**
         * Disconnect a broker account from the platform.
         * @summary Disconnect broker account
         * @param {BrokerAccountDisconnectRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        brokerAccountDisconnect(body: BrokerAccountDisconnectRequest, options?: RawAxiosRequestConfig): AxiosPromise<BrokerAccountDisconnect200Response> {
            return localVarFp.brokerAccountDisconnect(body, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieve a single broker account.
         * @summary Get broker account
         * @param {string} accountId Broker account identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        brokerAccountGet(accountId: string, options?: RawAxiosRequestConfig): AxiosPromise<BrokerAccountResponse> {
            return localVarFp.brokerAccountGet(accountId, options).then((request) => request(axios, basePath));
        },
        /**
         * Update broker account preferences.
         * @summary Update broker account
         * @param {string} accountId Broker account identifier
         * @param {BrokerAccountUpdateRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        brokerAccountUpdate(accountId: string, body: BrokerAccountUpdateRequest, options?: RawAxiosRequestConfig): AxiosPromise<BrokerAccountResponse> {
            return localVarFp.brokerAccountUpdate(accountId, body, options).then((request) => request(axios, basePath));
        },
        /**
         * List broker accounts linked to the authenticated user.
         * @summary List broker accounts
         * @param {string} [brokerType] Filter by broker type
         * @param {string} [status] Filter by account status
         * @param {boolean} [paperTrading] Filter by paper trading mode
         * @param {number} [limit] Maximum number of results
         * @param {number} [offset] Pagination offset
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        brokerAccountsList(brokerType?: string, status?: string, paperTrading?: boolean, limit?: number, offset?: number, options?: RawAxiosRequestConfig): AxiosPromise<BrokerAccountListResponse> {
            return localVarFp.brokerAccountsList(brokerType, status, paperTrading, limit, offset, options).then((request) => request(axios, basePath));
        },
        /**
         * Get list of all supported broker platforms. Public endpoint - no authentication required.
         * @summary Get supported brokers
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        brokerAccountsSupportedBrokers(options?: RawAxiosRequestConfig): AxiosPromise<SupportedBrokersResponse> {
            return localVarFp.brokerAccountsSupportedBrokers(options).then((request) => request(axios, basePath));
        },
        /**
         * Initiate broker account registration and OAuth flow.
         * @summary Register broker account
         * @param {BrokerRegistrationRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        brokerRegistration(body: BrokerRegistrationRequest, options?: RawAxiosRequestConfig): AxiosPromise<BrokerRegistrationResponse> {
            return localVarFp.brokerRegistration(body, options).then((request) => request(axios, basePath));
        },
        /**
         * Handle OAuth callbacks from broker partners. Public endpoint invoked by brokers.
         * @summary Broker OAuth callback
         * @param {string} brokerType Broker identifier
         * @param {string} [state] 
         * @param {string} [oauthState] 
         * @param {string} [code] 
         * @param {string} [requestToken] 
         * @param {string} [action] 
         * @param {string} [status] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        brokerRegistrationCallback(brokerType: string, state?: string, oauthState?: string, code?: string, requestToken?: string, action?: string, status?: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.brokerRegistrationCallback(brokerType, state, oauthState, code, requestToken, action, status, options).then((request) => request(axios, basePath));
        },
        /**
         * Deregister and delete a broker account by registration ID.
         * @summary Deregister broker account
         * @param {string} registrationId Registration identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        brokerRegistrationDeregister(registrationId: string, options?: RawAxiosRequestConfig): AxiosPromise<BrokerRegistrationDeregister200Response> {
            return localVarFp.brokerRegistrationDeregister(registrationId, options).then((request) => request(axios, basePath));
        },
        /**
         * Migrate existing OAuth account to TOTP-based automated authentication. Verifies account ownership and current auth_mode=\'oauth\', validates TOTP secret format, stores credentials in Secret Manager, performs one-time validation login, and updates account to TOTP mode if successful. Existing access token is preserved during migration.
         * @summary Migrate existing OAuth account to TOTP-based automated authentication
         * @param {string} registrationId Registration identifier
         * @param {BrokerRegistrationMigrateToTOTPRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        brokerRegistrationMigrateToTOTP(registrationId: string, body: BrokerRegistrationMigrateToTOTPRequest, options?: RawAxiosRequestConfig): AxiosPromise<MigrateToTOTPResponse> {
            return localVarFp.brokerRegistrationMigrateToTOTP(registrationId, body, options).then((request) => request(axios, basePath));
        },
        /**
         * Reconnect broker account. Routes to automated TOTP login or OAuth flow based on account auth_mode. If auth_mode=\'totp_automated\', performs automated login using stored TOTP credentials. If auth_mode=\'oauth\', returns OAuth URL for manual login.
         * @summary Reconnect broker account
         * @param {BrokerRegistrationReconnectRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        brokerRegistrationReconnect(body: BrokerRegistrationReconnectRequest, options?: RawAxiosRequestConfig): AxiosPromise<ReconnectResponse> {
            return localVarFp.brokerRegistrationReconnect(body, options).then((request) => request(axios, basePath));
        },
        /**
         * Check the status of a broker registration flow.
         * @summary Get registration status
         * @param {string} registrationId Registration identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        brokerRegistrationStatus(registrationId: string, options?: RawAxiosRequestConfig): AxiosPromise<ConnectionStatusResponse> {
            return localVarFp.brokerRegistrationStatus(registrationId, options).then((request) => request(axios, basePath));
        },
        /**
         * Register broker account with TOTP credentials for automated authentication. Supports any broker that implements automated login (e.g., Zerodha, Groww). Stores credentials securely in GCP Secret Manager, creates account record, performs one-time validation login, and returns registration details if successful. If validation fails, credentials are automatically cleaned up.
         * @summary Register broker account with TOTP credentials
         * @param {BrokerRegistrationTOTPRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        brokerRegistrationTOTP(body: BrokerRegistrationTOTPRequest, options?: RawAxiosRequestConfig): AxiosPromise<RegisterTOTPResponse> {
            return localVarFp.brokerRegistrationTOTP(body, options).then((request) => request(axios, basePath));
        },
        /**
         * Update TOTP credentials for an existing account. Verifies account ownership, validates new credentials format, updates credentials in Secret Manager, performs validation login with new credentials, and updates account metadata if successful. Requires account to be in TOTP mode (auth_mode=\'totp_automated\').
         * @summary Update TOTP credentials for existing account
         * @param {string} registrationId Registration identifier
         * @param {BrokerRegistrationUpdateTOTPCredentialsRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        brokerRegistrationUpdateTOTPCredentials(registrationId: string, body: BrokerRegistrationUpdateTOTPCredentialsRequest, options?: RawAxiosRequestConfig): AxiosPromise<UpdateCredentialsResponse> {
            return localVarFp.brokerRegistrationUpdateTOTPCredentials(registrationId, body, options).then((request) => request(axios, basePath));
        },
        /**
         * Updates a user\'s role. Caller must have the \'admin\' role — enforced server-side.
         * @summary Change user role (admin only)
         * @param {string} userId Target user\&#39;s UUID
         * @param {ChangeUserRoleRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        changeUserRole(userId: string, body: ChangeUserRoleRequest, options?: RawAxiosRequestConfig): AxiosPromise<CreateUser201Response> {
            return localVarFp.changeUserRole(userId, body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Check quota for resource type
         * @param {string} userId 
         * @param {CheckUserQuotaResourceTypeEnum} resourceType 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkUserQuota(userId: string, resourceType: CheckUserQuotaResourceTypeEnum, options?: RawAxiosRequestConfig): AxiosPromise<CheckUserQuota200Response> {
            return localVarFp.checkUserQuota(userId, resourceType, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create user
         * @param {CreateUserRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createUser(body: CreateUserRequest, options?: RawAxiosRequestConfig): AxiosPromise<CreateUser201Response> {
            return localVarFp.createUser(body, options).then((request) => request(axios, basePath));
        },
        /**
         * Create a new user category (admin only).
         * @summary Create user category
         * @param {CreateUserCategoryRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createUserCategory(body: CreateUserCategoryRequest, options?: RawAxiosRequestConfig): AxiosPromise<CreateUserCategory201Response> {
            return localVarFp.createUserCategory(body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create watchlist group
         * @param {CreateWatchlistGroupRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createWatchlistGroup(body: CreateWatchlistGroupRequest, options?: RawAxiosRequestConfig): AxiosPromise<CreateWatchlistGroup201Response> {
            return localVarFp.createWatchlistGroup(body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete user (soft delete)
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteUser(userId: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteUser(userId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete watchlist group
         * @param {string} groupId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteWatchlistGroup(groupId: string, options?: RawAxiosRequestConfig): AxiosPromise<DeleteWatchlistGroup200Response> {
            return localVarFp.deleteWatchlistGroup(groupId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Detailed health check
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        detailedHealthCheck(options?: RawAxiosRequestConfig): AxiosPromise<DetailedHealthCheck200Response> {
            return localVarFp.detailedHealthCheck(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get all watchlist groups
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllWatchlistGroups(options?: RawAxiosRequestConfig): AxiosPromise<GetAllWatchlistGroups200Response> {
            return localVarFp.getAllWatchlistGroups(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get all watchlist items in group
         * @param {string} groupId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllWatchlistItems(groupId: string, options?: RawAxiosRequestConfig): AxiosPromise<GetAllWatchlistItems200Response> {
            return localVarFp.getAllWatchlistItems(groupId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get current user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCurrentUser(options?: RawAxiosRequestConfig): AxiosPromise<GetCurrentUser200Response> {
            return localVarFp.getCurrentUser(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get current user\'s profile
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCurrentUserProfile(options?: RawAxiosRequestConfig): AxiosPromise<GetCurrentUserProfile200Response> {
            return localVarFp.getCurrentUserProfile(options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieve the instruments that make up a specific index.
         * @summary Get index constituents
         * @param {string} indexSymbol Index symbol (e.g., NIFTY 50)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getIndexConstituents(indexSymbol: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<InstrumentResponse>> {
            return localVarFp.getIndexConstituents(indexSymbol, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieve a list of all available market indices.
         * @summary Get all indices
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getIndices(options?: RawAxiosRequestConfig): AxiosPromise<Array<GetIndices200ResponseInner>> {
            return localVarFp.getIndices(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get user by ID
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserById(userId: string, options?: RawAxiosRequestConfig): AxiosPromise<GetUserById200Response> {
            return localVarFp.getUserById(userId, options).then((request) => request(axios, basePath));
        },
        /**
         * List all user categories (admin only). Reference data.
         * @summary List user categories
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserCategories(options?: RawAxiosRequestConfig): AxiosPromise<GetUserCategories200Response> {
            return localVarFp.getUserCategories(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get preference by key
         * @param {string} userId 
         * @param {string} key 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserPreference(userId: string, key: string, options?: RawAxiosRequestConfig): AxiosPromise<GetUserPreference200Response> {
            return localVarFp.getUserPreference(userId, key, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get all user preferences
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserPreferences(userId: string, options?: RawAxiosRequestConfig): AxiosPromise<GetUserPreferences200Response> {
            return localVarFp.getUserPreferences(userId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get user profile by user ID or Firebase UID
         * @param {string} userId User ID (UUID) or Firebase UID. If Firebase UID is provided, user will be looked up first.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserProfile(userId: string, options?: RawAxiosRequestConfig): AxiosPromise<GetCurrentUserProfile200Response> {
            return localVarFp.getUserProfile(userId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get user quotas
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserQuotas(userId: string, options?: RawAxiosRequestConfig): AxiosPromise<GetUserQuotas200Response> {
            return localVarFp.getUserQuotas(userId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get watchlist group
         * @param {string} groupId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWatchlistGroup(groupId: string, options?: RawAxiosRequestConfig): AxiosPromise<GetWatchlistGroup200Response> {
            return localVarFp.getWatchlistGroup(groupId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get watchlist item
         * @param {string} groupId 
         * @param {string} itemId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWatchlistItem(groupId: string, itemId: string, options?: RawAxiosRequestConfig): AxiosPromise<GetWatchlistItem200Response> {
            return localVarFp.getWatchlistItem(groupId, itemId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Basic health check
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        healthCheck(options?: RawAxiosRequestConfig): AxiosPromise<HealthCheck200Response> {
            return localVarFp.healthCheck(options).then((request) => request(axios, basePath));
        },
        /**
         * Fetch multiple instruments by ID in a single request.
         * @summary Batch fetch instruments
         * @param {InstrumentBatchRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        instrumentBatch(body: InstrumentBatchRequest, options?: RawAxiosRequestConfig): AxiosPromise<InstrumentListResponse> {
            return localVarFp.instrumentBatch(body, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieve futures instruments for a symbol.
         * @summary Get futures instruments
         * @param {string} symbol 
         * @param {string} [exchange] Exchange (default: NFO). Optional.
         * @param {string} [expiryStart] Start of expiry date range (YYYY-MM-DD)
         * @param {string} [expiryEnd] End of expiry date range (YYYY-MM-DD)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        instrumentFutures(symbol: string, exchange?: string, expiryStart?: string, expiryEnd?: string, options?: RawAxiosRequestConfig): AxiosPromise<{ [key: string]: any; }> {
            return localVarFp.instrumentFutures(symbol, exchange, expiryStart, expiryEnd, options).then((request) => request(axios, basePath));
        },
        /**
         * Fetch instrument master data by instrument identifier.
         * @summary Get instrument
         * @param {string} instrumentId Instrument identifier
         * @param {boolean} [includeMappings] Whether to include broker mappings in the response
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        instrumentGet(instrumentId: string, includeMappings?: boolean, options?: RawAxiosRequestConfig): AxiosPromise<InstrumentResponse> {
            return localVarFp.instrumentGet(instrumentId, includeMappings, options).then((request) => request(axios, basePath));
        },
        /**
         * Get broker-specific instrument token from symbol and broker type. Reverse operation of token resolution. Used when user selects an instrument symbol and needs the broker-specific token for their broker account.
         * @summary Get broker token by symbol
         * @param {string} symbol Trading symbol (e.g., \&#39;INFY\&#39;)
         * @param {string} broker Broker type (zerodha, upstox, dhan, etc.)
         * @param {string} [exchange] Exchange code (e.g., \&#39;NSE\&#39;, \&#39;BSE\&#39;). Optional, searches all if not provided.
         * @param {string} [expiryDate] Expiry date for derivatives (YYYY-MM-DD)
         * @param {number} [strikePrice] Strike price for options
         * @param {InstrumentGetTokenBySymbolOptionTypeEnum} [optionType] Option type (CE/PE) for options
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        instrumentGetTokenBySymbol(symbol: string, broker: string, exchange?: string, expiryDate?: string, strikePrice?: number, optionType?: InstrumentGetTokenBySymbolOptionTypeEnum, options?: RawAxiosRequestConfig): AxiosPromise<BrokerTokenResponse> {
            return localVarFp.instrumentGetTokenBySymbol(symbol, broker, exchange, expiryDate, strikePrice, optionType, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieve options chain data for a symbol.
         * @summary Get options chain
         * @param {string} symbol 
         * @param {string} expiryDate Expiry date (YYYY-MM-DD)
         * @param {string} [exchange] Exchange (default: NFO). Optional.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        instrumentOptionsChain(symbol: string, expiryDate: string, exchange?: string, options?: RawAxiosRequestConfig): AxiosPromise<{ [key: string]: any; }> {
            return localVarFp.instrumentOptionsChain(symbol, expiryDate, exchange, options).then((request) => request(axios, basePath));
        },
        /**
         * Search instruments by keyword with exchange filters. When include_mappings=true, each instrument includes broker_mappings (which brokers have this instrument). Default false for performance; use true only in admin/reference UIs.
         * @summary Search instruments
         * @param {string} query Search keyword
         * @param {string} [exchange] Optional exchange filter
         * @param {string} [segment] Optional segment filter
         * @param {string} [sector] Optional sector filter
         * @param {string} [instrumentType] Optional instrument type filter
         * @param {boolean} [isActive] Filter by active status
         * @param {number} [limit] Maximum search results
         * @param {number} [offset] Pagination offset
         * @param {boolean} [includeMappings] Include broker_mappings per instrument (which brokers have it). Use only in admin/reference UIs; keep false for instrument sidebar for performance.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        instrumentSearch(query: string, exchange?: string, segment?: string, sector?: string, instrumentType?: string, isActive?: boolean, limit?: number, offset?: number, includeMappings?: boolean, options?: RawAxiosRequestConfig): AxiosPromise<InstrumentListResponse> {
            return localVarFp.instrumentSearch(query, exchange, segment, sector, instrumentType, isActive, limit, offset, includeMappings, options).then((request) => request(axios, basePath));
        },
        /**
         * Resolve a broker-specific token or symbol to a platform instrument.
         * @summary Resolve broker token
         * @param {string} broker Broker identifier
         * @param {string} token Broker token/symbol
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        instrumentTokenResolve(broker: string, token: string, options?: RawAxiosRequestConfig): AxiosPromise<TokenResolutionResponse> {
            return localVarFp.instrumentTokenResolve(broker, token, options).then((request) => request(axios, basePath));
        },
        /**
         * Resolve multiple broker tokens to platform instruments.
         * @summary Batch resolve broker tokens
         * @param {InstrumentTokenResolveBatchRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        instrumentTokenResolveBatch(body: InstrumentTokenResolveBatchRequest, options?: RawAxiosRequestConfig): AxiosPromise<InstrumentTokenResolveBatch200Response> {
            return localVarFp.instrumentTokenResolveBatch(body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary List users
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [email] Filter by email (partial match)
         * @param {ListUsersStatusEnum} [status] 
         * @param {ListUsersRoleEnum} [role] Filter by role
         * @param {boolean} [isActive] Filter by active status
         * @param {string} [categoryId] Filter by category ID
         * @param {string} [sortBy] 
         * @param {ListUsersSortOrderEnum} [sortOrder] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listUsers(page?: number, size?: number, email?: string, status?: ListUsersStatusEnum, role?: ListUsersRoleEnum, isActive?: boolean, categoryId?: string, sortBy?: string, sortOrder?: ListUsersSortOrderEnum, options?: RawAxiosRequestConfig): AxiosPromise<ListUsers200Response> {
            return localVarFp.listUsers(page, size, email, status, role, isActive, categoryId, sortBy, sortOrder, options).then((request) => request(axios, basePath));
        },
        /**
         * Place multiple orders simultaneously with concurrency control. Supports SIMPLE orders only (market, limit, stop, stop_limit).
         * @summary Place batch orders
         * @param {OrdersBatchRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ordersBatch(body: OrdersBatchRequest, options?: RawAxiosRequestConfig): AxiosPromise<OrdersBatch200Response> {
            return localVarFp.ordersBatch(body, options).then((request) => request(axios, basePath));
        },
        /**
         * Cancel an existing order and return its final state.
         * @summary Cancel order
         * @param {string} platformOrderId Platform order identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ordersCancel(platformOrderId: string, options?: RawAxiosRequestConfig): AxiosPromise<OrderResponse> {
            return localVarFp.ordersCancel(platformOrderId, options).then((request) => request(axios, basePath));
        },
        /**
         * Create a new order and place it with the configured broker. Supports market, limit, stop, trailing stop, iceberg and multi-leg strategies.
         * @summary Create order
         * @param {OrdersCreateRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ordersCreate(body: OrdersCreateRequest, options?: RawAxiosRequestConfig): AxiosPromise<OrderResponse> {
            return localVarFp.ordersCreate(body, options).then((request) => request(axios, basePath));
        },
        /**
         * Fetch a single order with broker sync details and fills.
         * @summary Get order
         * @param {string} platformOrderId Platform order identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ordersGet(platformOrderId: string, options?: RawAxiosRequestConfig): AxiosPromise<OrderResponse> {
            return localVarFp.ordersGet(platformOrderId, options).then((request) => request(axios, basePath));
        },
        /**
         * List orders for the authenticated user with filtering and pagination.
         * @summary List orders
         * @param {string} [status] Filter by order status
         * @param {string} [instrumentId] Filter by instrument identifier
         * @param {number} [limit] Number of records to return
         * @param {number} [offset] Pagination offset
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ordersList(status?: string, instrumentId?: string, limit?: number, offset?: number, options?: RawAxiosRequestConfig): AxiosPromise<OrdersList200Response> {
            return localVarFp.ordersList(status, instrumentId, limit, offset, options).then((request) => request(axios, basePath));
        },
        /**
         * Modify an existing order. Only orders in PENDING or PLACED status can be modified. Only certain fields can be updated (quantity, price, stop_price, limit_price, notes).
         * @summary Modify order
         * @param {string} platformOrderId Platform order identifier
         * @param {OrdersModifyRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ordersModify(platformOrderId: string, body: OrdersModifyRequest, options?: RawAxiosRequestConfig): AxiosPromise<OrderResponse> {
            return localVarFp.ordersModify(platformOrderId, body, options).then((request) => request(axios, basePath));
        },
        /**
         * Manually trigger synchronization of order details from broker and update the broker_orders table.
         * @summary Sync order from broker
         * @param {string} platformOrderId Platform order identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ordersSync(platformOrderId: string, options?: RawAxiosRequestConfig): AxiosPromise<OrderResponse> {
            return localVarFp.ordersSync(platformOrderId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get chronological timeline of all events for an order, combining data from platform_orders, order_status_log, order_fills, and broker_orders.
         * @summary Get order timeline
         * @param {string} platformOrderId Platform order identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ordersTimeline(platformOrderId: string, options?: RawAxiosRequestConfig): AxiosPromise<OrdersTimeline200Response> {
            return localVarFp.ordersTimeline(platformOrderId, options).then((request) => request(axios, basePath));
        },
        /**
         * Delete all portfolio data (holdings and transactions) for a broker account. This endpoint is called automatically when a broker account is deregistered/deleted. It removes all associated portfolio data including holdings and transactions. **Security**: Deletion requires BOTH firebase_uid (from authenticated user) AND broker_account_id to match, ensuring data belongs to the user before deletion.
         * @summary Delete portfolio data for broker account
         * @param {string} brokerAccountId Broker account identifier (String, matches broker_accounts.accounts.broker_account_id)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        portfolioAccountDelete(brokerAccountId: string, options?: RawAxiosRequestConfig): AxiosPromise<PortfolioAccountDelete200Response> {
            return localVarFp.portfolioAccountDelete(brokerAccountId, options).then((request) => request(axios, basePath));
        },
        /**
         * Return aggregated portfolio snapshot, broker account summaries, and top holdings for the authenticated user.
         * @summary Get consolidated portfolio
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        portfolioGet(options?: RawAxiosRequestConfig): AxiosPromise<PortfolioGet200Response> {
            return localVarFp.portfolioGet(options).then((request) => request(axios, basePath));
        },
        /**
         * Get a specific holding for the authenticated user.
         * @summary Get holding
         * @param {string} holdingId Holding identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        portfolioHoldingGet(holdingId: string, options?: RawAxiosRequestConfig): AxiosPromise<HoldingResponse> {
            return localVarFp.portfolioHoldingGet(holdingId, options).then((request) => request(axios, basePath));
        },
        /**
         * Return holdings for the authenticated user with optional broker and symbol filters.
         * @summary List holdings
         * @param {string} [brokerAccountId] Filter holdings by broker account
         * @param {string} [symbol] Filter by instrument symbol
         * @param {string} [exchange] Filter by exchange
         * @param {string} [productType] Filter by product type
         * @param {boolean} [includeClosed] Include closed positions
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        portfolioHoldingsList(brokerAccountId?: string, symbol?: string, exchange?: string, productType?: string, includeClosed?: boolean, options?: RawAxiosRequestConfig): AxiosPromise<PortfolioHoldingsList200Response> {
            return localVarFp.portfolioHoldingsList(brokerAccountId, symbol, exchange, productType, includeClosed, options).then((request) => request(axios, basePath));
        },
        /**
         * Manual portfolio sync. When broker_account_id is omitted, syncs all connected broker accounts for the user. When broker_account_id is provided, syncs only that account. 
         * @summary Trigger portfolio sync
         * @param {PortfolioSyncRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        portfolioSync(body: PortfolioSyncRequest, options?: RawAxiosRequestConfig): AxiosPromise<PortfolioSync200Response> {
            return localVarFp.portfolioSync(body, options).then((request) => request(axios, basePath));
        },
        /**
         * Return historical sync operations for a broker account.
         * @summary Get sync history
         * @param {string} brokerAccountId Broker account identifier
         * @param {number} [limit] Maximum sync logs to return
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        portfolioSyncHistory(brokerAccountId: string, limit?: number, options?: RawAxiosRequestConfig): AxiosPromise<Array<{ [key: string]: any; }>> {
            return localVarFp.portfolioSyncHistory(brokerAccountId, limit, options).then((request) => request(axios, basePath));
        },
        /**
         * Return recent sync operations for a broker account.
         * @summary Get recent sync status
         * @param {string} brokerAccountId Broker account identifier
         * @param {number} [limit] Maximum sync logs to return
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        portfolioSyncStatus(brokerAccountId: string, limit?: number, options?: RawAxiosRequestConfig): AxiosPromise<Array<{ [key: string]: any; }>> {
            return localVarFp.portfolioSyncStatus(brokerAccountId, limit, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieve an individual transaction.
         * @summary Get transaction
         * @param {string} transactionId Transaction identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        portfolioTransactionGet(transactionId: string, options?: RawAxiosRequestConfig): AxiosPromise<TransactionResponse> {
            return localVarFp.portfolioTransactionGet(transactionId, options).then((request) => request(axios, basePath));
        },
        /**
         * Return transaction history with pagination and optional filters.
         * @summary List transactions
         * @param {string} [brokerAccountId] Filter by broker account
         * @param {string} [transactionType] Filter by type (buy/sell)
         * @param {string} [symbol] 
         * @param {string} [exchange] 
         * @param {string} [fromDate] 
         * @param {string} [toDate] 
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        portfolioTransactionsList(brokerAccountId?: string, transactionType?: string, symbol?: string, exchange?: string, fromDate?: string, toDate?: string, limit?: number, offset?: number, options?: RawAxiosRequestConfig): AxiosPromise<PortfolioTransactionsList200Response> {
            return localVarFp.portfolioTransactionsList(brokerAccountId, transactionType, symbol, exchange, fromDate, toDate, limit, offset, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Remove watchlist item by item ID
         * @param {string} groupId 
         * @param {string} itemId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeWatchlistItem(groupId: string, itemId: string, options?: RawAxiosRequestConfig): AxiosPromise<DeleteWatchlistGroup200Response> {
            return localVarFp.removeWatchlistItem(groupId, itemId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Remove instrument from watchlist group by instrument ID
         * @param {string} userId 
         * @param {string} groupId 
         * @param {string} instrumentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeWatchlistItemByInstrument(userId: string, groupId: string, instrumentId: string, options?: RawAxiosRequestConfig): AxiosPromise<DeleteWatchlistGroup200Response> {
            return localVarFp.removeWatchlistItemByInstrument(userId, groupId, instrumentId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Set preference
         * @param {string} userId 
         * @param {string} key 
         * @param {SetUserPreferenceRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setUserPreference(userId: string, key: string, body: SetUserPreferenceRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.setUserPreference(userId, key, body, options).then((request) => request(axios, basePath));
        },
        /**
         * Activate or deactivate a supported broker. Admin only.
         * @summary Update broker status
         * @param {string} brokerType 
         * @param {UpdateBrokerStatusRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateBrokerStatus(brokerType: string, body: UpdateBrokerStatusRequest, options?: RawAxiosRequestConfig): AxiosPromise<BrokerMetadataResponse> {
            return localVarFp.updateBrokerStatus(brokerType, body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update current user\'s profile
         * @param {UpdateCurrentUserProfileRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCurrentUserProfile(body: UpdateCurrentUserProfileRequest, options?: RawAxiosRequestConfig): AxiosPromise<CreateUser201Response> {
            return localVarFp.updateCurrentUserProfile(body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update user
         * @param {string} userId 
         * @param {object} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateUser(userId: string, body: object, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.updateUser(userId, body, options).then((request) => request(axios, basePath));
        },
        /**
         * Update an existing user category (admin only).
         * @summary Update user category
         * @param {string} categoryId 
         * @param {UpdateUserCategoryRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateUserCategory(categoryId: string, body: UpdateUserCategoryRequest, options?: RawAxiosRequestConfig): AxiosPromise<CreateUserCategory201Response> {
            return localVarFp.updateUserCategory(categoryId, body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update user profile by user ID or Firebase UID
         * @param {string} userId User ID (UUID) or Firebase UID. If Firebase UID is provided, user will be looked up first.
         * @param {UpdateCurrentUserProfileRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateUserProfile(userId: string, body: UpdateCurrentUserProfileRequest, options?: RawAxiosRequestConfig): AxiosPromise<CreateUser201Response> {
            return localVarFp.updateUserProfile(userId, body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update watchlist group
         * @param {string} groupId 
         * @param {UpdateWatchlistGroupRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateWatchlistGroup(groupId: string, body: UpdateWatchlistGroupRequest, options?: RawAxiosRequestConfig): AxiosPromise<CreateWatchlistGroup201Response> {
            return localVarFp.updateWatchlistGroup(groupId, body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update watchlist item
         * @param {string} groupId 
         * @param {string} itemId 
         * @param {UpdateWatchlistItemRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateWatchlistItem(groupId: string, itemId: string, body: UpdateWatchlistItemRequest, options?: RawAxiosRequestConfig): AxiosPromise<AddWatchlistItem201Response> {
            return localVarFp.updateWatchlistItem(groupId, itemId, body, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * DefaultApi - interface
 */
export interface DefaultApiInterface {
    /**
     * Registers a new supported broker. Admin only.
     * @summary Add a supported broker
     * @param {AddSupportedBrokerRequest} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    addSupportedBroker(body: AddSupportedBrokerRequest, options?: RawAxiosRequestConfig): AxiosPromise<BrokerMetadataResponse>;

    /**
     * 
     * @summary Add instrument to watchlist group
     * @param {string} groupId 
     * @param {AddWatchlistItemRequest} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    addWatchlistItem(groupId: string, body: AddWatchlistItemRequest, options?: RawAxiosRequestConfig): AxiosPromise<AddWatchlistItem201Response>;

    /**
     * Send AG-UI RunAgentInput request and stream AG-UI protocol events (SSE or JSON-lines format). Uses AG-UI protocol libraries for request/response handling.
     * @summary AG-UI protocol endpoint - stream agent responses
     * @param {AiAssistAguiStreamRequest} body AG-UI RunAgentInput request (from @ag-ui/core library)
     * @param {string} [accept] Response format: \&#39;text/event-stream\&#39; (SSE) or \&#39;application/x-ndjson\&#39; (JSON-lines)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    aiAssistAguiStream(body: AiAssistAguiStreamRequest, accept?: string, options?: RawAxiosRequestConfig): AxiosPromise<AiAssistAguiStream200Response>;

    /**
     * Delete a session from Vertex AI Agent Engine. This permanently removes the session and all its associated messages.
     * @summary Delete an ADK session
     * @param {string} sessionId ADK session ID to delete
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    aiAssistSessionDelete(sessionId: string, options?: RawAxiosRequestConfig): AxiosPromise<AiAssistSessionDelete200Response>;

    /**
     * Retrieve all messages (events) associated with a specific session from Vertex AI Agent Engine. The messages are returned in chronological order.
     * @summary Get message history for a specific ADK session
     * @param {string} sessionId ADK session ID to retrieve messages for
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    aiAssistSessionMessagesGet(sessionId: string, options?: RawAxiosRequestConfig): AxiosPromise<GetSessionMessagesResponse>;

    /**
     * Update the display name for a session. The session_id itself cannot be changed, but a custom display name can be stored and displayed in the UI.
     * @summary Update session display name
     * @param {string} sessionId ADK session ID to update
     * @param {UpdateSessionDisplayNameRequest} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    aiAssistSessionUpdate(sessionId: string, body: UpdateSessionDisplayNameRequest, options?: RawAxiosRequestConfig): AxiosPromise<AiAssistSessionUpdate200Response>;

    /**
     * Create a new ADK session in Vertex AI Agent Engine. The returned session_id should be used in all subsequent AG-UI requests (via threadId field) to maintain conversation continuity across multiple user messages.
     * @summary Create ADK session for conversation continuity
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    aiAssistSessionsCreate(options?: RawAxiosRequestConfig): AxiosPromise<CreateSessionResponse>;

    /**
     * Retrieve all sessions associated with the authenticated user from Vertex AI Agent Engine. Sessions are returned as a list of session IDs that can be used for conversation continuity.
     * @summary List all ADK sessions for the authenticated user
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    aiAssistSessionsList(options?: RawAxiosRequestConfig): AxiosPromise<ListSessionsResponse>;

    /**
     * Disconnect a broker account from the platform.
     * @summary Disconnect broker account
     * @param {BrokerAccountDisconnectRequest} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    brokerAccountDisconnect(body: BrokerAccountDisconnectRequest, options?: RawAxiosRequestConfig): AxiosPromise<BrokerAccountDisconnect200Response>;

    /**
     * Retrieve a single broker account.
     * @summary Get broker account
     * @param {string} accountId Broker account identifier
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    brokerAccountGet(accountId: string, options?: RawAxiosRequestConfig): AxiosPromise<BrokerAccountResponse>;

    /**
     * Update broker account preferences.
     * @summary Update broker account
     * @param {string} accountId Broker account identifier
     * @param {BrokerAccountUpdateRequest} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    brokerAccountUpdate(accountId: string, body: BrokerAccountUpdateRequest, options?: RawAxiosRequestConfig): AxiosPromise<BrokerAccountResponse>;

    /**
     * List broker accounts linked to the authenticated user.
     * @summary List broker accounts
     * @param {string} [brokerType] Filter by broker type
     * @param {string} [status] Filter by account status
     * @param {boolean} [paperTrading] Filter by paper trading mode
     * @param {number} [limit] Maximum number of results
     * @param {number} [offset] Pagination offset
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    brokerAccountsList(brokerType?: string, status?: string, paperTrading?: boolean, limit?: number, offset?: number, options?: RawAxiosRequestConfig): AxiosPromise<BrokerAccountListResponse>;

    /**
     * Get list of all supported broker platforms. Public endpoint - no authentication required.
     * @summary Get supported brokers
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    brokerAccountsSupportedBrokers(options?: RawAxiosRequestConfig): AxiosPromise<SupportedBrokersResponse>;

    /**
     * Initiate broker account registration and OAuth flow.
     * @summary Register broker account
     * @param {BrokerRegistrationRequest} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    brokerRegistration(body: BrokerRegistrationRequest, options?: RawAxiosRequestConfig): AxiosPromise<BrokerRegistrationResponse>;

    /**
     * Handle OAuth callbacks from broker partners. Public endpoint invoked by brokers.
     * @summary Broker OAuth callback
     * @param {string} brokerType Broker identifier
     * @param {string} [state] 
     * @param {string} [oauthState] 
     * @param {string} [code] 
     * @param {string} [requestToken] 
     * @param {string} [action] 
     * @param {string} [status] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    brokerRegistrationCallback(brokerType: string, state?: string, oauthState?: string, code?: string, requestToken?: string, action?: string, status?: string, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * Deregister and delete a broker account by registration ID.
     * @summary Deregister broker account
     * @param {string} registrationId Registration identifier
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    brokerRegistrationDeregister(registrationId: string, options?: RawAxiosRequestConfig): AxiosPromise<BrokerRegistrationDeregister200Response>;

    /**
     * Migrate existing OAuth account to TOTP-based automated authentication. Verifies account ownership and current auth_mode=\'oauth\', validates TOTP secret format, stores credentials in Secret Manager, performs one-time validation login, and updates account to TOTP mode if successful. Existing access token is preserved during migration.
     * @summary Migrate existing OAuth account to TOTP-based automated authentication
     * @param {string} registrationId Registration identifier
     * @param {BrokerRegistrationMigrateToTOTPRequest} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    brokerRegistrationMigrateToTOTP(registrationId: string, body: BrokerRegistrationMigrateToTOTPRequest, options?: RawAxiosRequestConfig): AxiosPromise<MigrateToTOTPResponse>;

    /**
     * Reconnect broker account. Routes to automated TOTP login or OAuth flow based on account auth_mode. If auth_mode=\'totp_automated\', performs automated login using stored TOTP credentials. If auth_mode=\'oauth\', returns OAuth URL for manual login.
     * @summary Reconnect broker account
     * @param {BrokerRegistrationReconnectRequest} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    brokerRegistrationReconnect(body: BrokerRegistrationReconnectRequest, options?: RawAxiosRequestConfig): AxiosPromise<ReconnectResponse>;

    /**
     * Check the status of a broker registration flow.
     * @summary Get registration status
     * @param {string} registrationId Registration identifier
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    brokerRegistrationStatus(registrationId: string, options?: RawAxiosRequestConfig): AxiosPromise<ConnectionStatusResponse>;

    /**
     * Register broker account with TOTP credentials for automated authentication. Supports any broker that implements automated login (e.g., Zerodha, Groww). Stores credentials securely in GCP Secret Manager, creates account record, performs one-time validation login, and returns registration details if successful. If validation fails, credentials are automatically cleaned up.
     * @summary Register broker account with TOTP credentials
     * @param {BrokerRegistrationTOTPRequest} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    brokerRegistrationTOTP(body: BrokerRegistrationTOTPRequest, options?: RawAxiosRequestConfig): AxiosPromise<RegisterTOTPResponse>;

    /**
     * Update TOTP credentials for an existing account. Verifies account ownership, validates new credentials format, updates credentials in Secret Manager, performs validation login with new credentials, and updates account metadata if successful. Requires account to be in TOTP mode (auth_mode=\'totp_automated\').
     * @summary Update TOTP credentials for existing account
     * @param {string} registrationId Registration identifier
     * @param {BrokerRegistrationUpdateTOTPCredentialsRequest} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    brokerRegistrationUpdateTOTPCredentials(registrationId: string, body: BrokerRegistrationUpdateTOTPCredentialsRequest, options?: RawAxiosRequestConfig): AxiosPromise<UpdateCredentialsResponse>;

    /**
     * Updates a user\'s role. Caller must have the \'admin\' role — enforced server-side.
     * @summary Change user role (admin only)
     * @param {string} userId Target user\&#39;s UUID
     * @param {ChangeUserRoleRequest} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    changeUserRole(userId: string, body: ChangeUserRoleRequest, options?: RawAxiosRequestConfig): AxiosPromise<CreateUser201Response>;

    /**
     * 
     * @summary Check quota for resource type
     * @param {string} userId 
     * @param {CheckUserQuotaResourceTypeEnum} resourceType 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    checkUserQuota(userId: string, resourceType: CheckUserQuotaResourceTypeEnum, options?: RawAxiosRequestConfig): AxiosPromise<CheckUserQuota200Response>;

    /**
     * 
     * @summary Create user
     * @param {CreateUserRequest} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createUser(body: CreateUserRequest, options?: RawAxiosRequestConfig): AxiosPromise<CreateUser201Response>;

    /**
     * Create a new user category (admin only).
     * @summary Create user category
     * @param {CreateUserCategoryRequest} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createUserCategory(body: CreateUserCategoryRequest, options?: RawAxiosRequestConfig): AxiosPromise<CreateUserCategory201Response>;

    /**
     * 
     * @summary Create watchlist group
     * @param {CreateWatchlistGroupRequest} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createWatchlistGroup(body: CreateWatchlistGroupRequest, options?: RawAxiosRequestConfig): AxiosPromise<CreateWatchlistGroup201Response>;

    /**
     * 
     * @summary Delete user (soft delete)
     * @param {string} userId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteUser(userId: string, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * 
     * @summary Delete watchlist group
     * @param {string} groupId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteWatchlistGroup(groupId: string, options?: RawAxiosRequestConfig): AxiosPromise<DeleteWatchlistGroup200Response>;

    /**
     * 
     * @summary Detailed health check
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    detailedHealthCheck(options?: RawAxiosRequestConfig): AxiosPromise<DetailedHealthCheck200Response>;

    /**
     * 
     * @summary Get all watchlist groups
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getAllWatchlistGroups(options?: RawAxiosRequestConfig): AxiosPromise<GetAllWatchlistGroups200Response>;

    /**
     * 
     * @summary Get all watchlist items in group
     * @param {string} groupId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getAllWatchlistItems(groupId: string, options?: RawAxiosRequestConfig): AxiosPromise<GetAllWatchlistItems200Response>;

    /**
     * 
     * @summary Get current user
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getCurrentUser(options?: RawAxiosRequestConfig): AxiosPromise<GetCurrentUser200Response>;

    /**
     * 
     * @summary Get current user\'s profile
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getCurrentUserProfile(options?: RawAxiosRequestConfig): AxiosPromise<GetCurrentUserProfile200Response>;

    /**
     * Retrieve the instruments that make up a specific index.
     * @summary Get index constituents
     * @param {string} indexSymbol Index symbol (e.g., NIFTY 50)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getIndexConstituents(indexSymbol: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<InstrumentResponse>>;

    /**
     * Retrieve a list of all available market indices.
     * @summary Get all indices
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getIndices(options?: RawAxiosRequestConfig): AxiosPromise<Array<GetIndices200ResponseInner>>;

    /**
     * 
     * @summary Get user by ID
     * @param {string} userId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getUserById(userId: string, options?: RawAxiosRequestConfig): AxiosPromise<GetUserById200Response>;

    /**
     * List all user categories (admin only). Reference data.
     * @summary List user categories
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getUserCategories(options?: RawAxiosRequestConfig): AxiosPromise<GetUserCategories200Response>;

    /**
     * 
     * @summary Get preference by key
     * @param {string} userId 
     * @param {string} key 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getUserPreference(userId: string, key: string, options?: RawAxiosRequestConfig): AxiosPromise<GetUserPreference200Response>;

    /**
     * 
     * @summary Get all user preferences
     * @param {string} userId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getUserPreferences(userId: string, options?: RawAxiosRequestConfig): AxiosPromise<GetUserPreferences200Response>;

    /**
     * 
     * @summary Get user profile by user ID or Firebase UID
     * @param {string} userId User ID (UUID) or Firebase UID. If Firebase UID is provided, user will be looked up first.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getUserProfile(userId: string, options?: RawAxiosRequestConfig): AxiosPromise<GetCurrentUserProfile200Response>;

    /**
     * 
     * @summary Get user quotas
     * @param {string} userId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getUserQuotas(userId: string, options?: RawAxiosRequestConfig): AxiosPromise<GetUserQuotas200Response>;

    /**
     * 
     * @summary Get watchlist group
     * @param {string} groupId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getWatchlistGroup(groupId: string, options?: RawAxiosRequestConfig): AxiosPromise<GetWatchlistGroup200Response>;

    /**
     * 
     * @summary Get watchlist item
     * @param {string} groupId 
     * @param {string} itemId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getWatchlistItem(groupId: string, itemId: string, options?: RawAxiosRequestConfig): AxiosPromise<GetWatchlistItem200Response>;

    /**
     * 
     * @summary Basic health check
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    healthCheck(options?: RawAxiosRequestConfig): AxiosPromise<HealthCheck200Response>;

    /**
     * Fetch multiple instruments by ID in a single request.
     * @summary Batch fetch instruments
     * @param {InstrumentBatchRequest} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    instrumentBatch(body: InstrumentBatchRequest, options?: RawAxiosRequestConfig): AxiosPromise<InstrumentListResponse>;

    /**
     * Retrieve futures instruments for a symbol.
     * @summary Get futures instruments
     * @param {string} symbol 
     * @param {string} [exchange] Exchange (default: NFO). Optional.
     * @param {string} [expiryStart] Start of expiry date range (YYYY-MM-DD)
     * @param {string} [expiryEnd] End of expiry date range (YYYY-MM-DD)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    instrumentFutures(symbol: string, exchange?: string, expiryStart?: string, expiryEnd?: string, options?: RawAxiosRequestConfig): AxiosPromise<{ [key: string]: any; }>;

    /**
     * Fetch instrument master data by instrument identifier.
     * @summary Get instrument
     * @param {string} instrumentId Instrument identifier
     * @param {boolean} [includeMappings] Whether to include broker mappings in the response
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    instrumentGet(instrumentId: string, includeMappings?: boolean, options?: RawAxiosRequestConfig): AxiosPromise<InstrumentResponse>;

    /**
     * Get broker-specific instrument token from symbol and broker type. Reverse operation of token resolution. Used when user selects an instrument symbol and needs the broker-specific token for their broker account.
     * @summary Get broker token by symbol
     * @param {string} symbol Trading symbol (e.g., \&#39;INFY\&#39;)
     * @param {string} broker Broker type (zerodha, upstox, dhan, etc.)
     * @param {string} [exchange] Exchange code (e.g., \&#39;NSE\&#39;, \&#39;BSE\&#39;). Optional, searches all if not provided.
     * @param {string} [expiryDate] Expiry date for derivatives (YYYY-MM-DD)
     * @param {number} [strikePrice] Strike price for options
     * @param {InstrumentGetTokenBySymbolOptionTypeEnum} [optionType] Option type (CE/PE) for options
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    instrumentGetTokenBySymbol(symbol: string, broker: string, exchange?: string, expiryDate?: string, strikePrice?: number, optionType?: InstrumentGetTokenBySymbolOptionTypeEnum, options?: RawAxiosRequestConfig): AxiosPromise<BrokerTokenResponse>;

    /**
     * Retrieve options chain data for a symbol.
     * @summary Get options chain
     * @param {string} symbol 
     * @param {string} expiryDate Expiry date (YYYY-MM-DD)
     * @param {string} [exchange] Exchange (default: NFO). Optional.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    instrumentOptionsChain(symbol: string, expiryDate: string, exchange?: string, options?: RawAxiosRequestConfig): AxiosPromise<{ [key: string]: any; }>;

    /**
     * Search instruments by keyword with exchange filters. When include_mappings=true, each instrument includes broker_mappings (which brokers have this instrument). Default false for performance; use true only in admin/reference UIs.
     * @summary Search instruments
     * @param {string} query Search keyword
     * @param {string} [exchange] Optional exchange filter
     * @param {string} [segment] Optional segment filter
     * @param {string} [sector] Optional sector filter
     * @param {string} [instrumentType] Optional instrument type filter
     * @param {boolean} [isActive] Filter by active status
     * @param {number} [limit] Maximum search results
     * @param {number} [offset] Pagination offset
     * @param {boolean} [includeMappings] Include broker_mappings per instrument (which brokers have it). Use only in admin/reference UIs; keep false for instrument sidebar for performance.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    instrumentSearch(query: string, exchange?: string, segment?: string, sector?: string, instrumentType?: string, isActive?: boolean, limit?: number, offset?: number, includeMappings?: boolean, options?: RawAxiosRequestConfig): AxiosPromise<InstrumentListResponse>;

    /**
     * Resolve a broker-specific token or symbol to a platform instrument.
     * @summary Resolve broker token
     * @param {string} broker Broker identifier
     * @param {string} token Broker token/symbol
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    instrumentTokenResolve(broker: string, token: string, options?: RawAxiosRequestConfig): AxiosPromise<TokenResolutionResponse>;

    /**
     * Resolve multiple broker tokens to platform instruments.
     * @summary Batch resolve broker tokens
     * @param {InstrumentTokenResolveBatchRequest} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    instrumentTokenResolveBatch(body: InstrumentTokenResolveBatchRequest, options?: RawAxiosRequestConfig): AxiosPromise<InstrumentTokenResolveBatch200Response>;

    /**
     * 
     * @summary List users
     * @param {number} [page] 
     * @param {number} [size] 
     * @param {string} [email] Filter by email (partial match)
     * @param {ListUsersStatusEnum} [status] 
     * @param {ListUsersRoleEnum} [role] Filter by role
     * @param {boolean} [isActive] Filter by active status
     * @param {string} [categoryId] Filter by category ID
     * @param {string} [sortBy] 
     * @param {ListUsersSortOrderEnum} [sortOrder] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    listUsers(page?: number, size?: number, email?: string, status?: ListUsersStatusEnum, role?: ListUsersRoleEnum, isActive?: boolean, categoryId?: string, sortBy?: string, sortOrder?: ListUsersSortOrderEnum, options?: RawAxiosRequestConfig): AxiosPromise<ListUsers200Response>;

    /**
     * Place multiple orders simultaneously with concurrency control. Supports SIMPLE orders only (market, limit, stop, stop_limit).
     * @summary Place batch orders
     * @param {OrdersBatchRequest} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    ordersBatch(body: OrdersBatchRequest, options?: RawAxiosRequestConfig): AxiosPromise<OrdersBatch200Response>;

    /**
     * Cancel an existing order and return its final state.
     * @summary Cancel order
     * @param {string} platformOrderId Platform order identifier
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    ordersCancel(platformOrderId: string, options?: RawAxiosRequestConfig): AxiosPromise<OrderResponse>;

    /**
     * Create a new order and place it with the configured broker. Supports market, limit, stop, trailing stop, iceberg and multi-leg strategies.
     * @summary Create order
     * @param {OrdersCreateRequest} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    ordersCreate(body: OrdersCreateRequest, options?: RawAxiosRequestConfig): AxiosPromise<OrderResponse>;

    /**
     * Fetch a single order with broker sync details and fills.
     * @summary Get order
     * @param {string} platformOrderId Platform order identifier
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    ordersGet(platformOrderId: string, options?: RawAxiosRequestConfig): AxiosPromise<OrderResponse>;

    /**
     * List orders for the authenticated user with filtering and pagination.
     * @summary List orders
     * @param {string} [status] Filter by order status
     * @param {string} [instrumentId] Filter by instrument identifier
     * @param {number} [limit] Number of records to return
     * @param {number} [offset] Pagination offset
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    ordersList(status?: string, instrumentId?: string, limit?: number, offset?: number, options?: RawAxiosRequestConfig): AxiosPromise<OrdersList200Response>;

    /**
     * Modify an existing order. Only orders in PENDING or PLACED status can be modified. Only certain fields can be updated (quantity, price, stop_price, limit_price, notes).
     * @summary Modify order
     * @param {string} platformOrderId Platform order identifier
     * @param {OrdersModifyRequest} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    ordersModify(platformOrderId: string, body: OrdersModifyRequest, options?: RawAxiosRequestConfig): AxiosPromise<OrderResponse>;

    /**
     * Manually trigger synchronization of order details from broker and update the broker_orders table.
     * @summary Sync order from broker
     * @param {string} platformOrderId Platform order identifier
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    ordersSync(platformOrderId: string, options?: RawAxiosRequestConfig): AxiosPromise<OrderResponse>;

    /**
     * Get chronological timeline of all events for an order, combining data from platform_orders, order_status_log, order_fills, and broker_orders.
     * @summary Get order timeline
     * @param {string} platformOrderId Platform order identifier
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    ordersTimeline(platformOrderId: string, options?: RawAxiosRequestConfig): AxiosPromise<OrdersTimeline200Response>;

    /**
     * Delete all portfolio data (holdings and transactions) for a broker account. This endpoint is called automatically when a broker account is deregistered/deleted. It removes all associated portfolio data including holdings and transactions. **Security**: Deletion requires BOTH firebase_uid (from authenticated user) AND broker_account_id to match, ensuring data belongs to the user before deletion.
     * @summary Delete portfolio data for broker account
     * @param {string} brokerAccountId Broker account identifier (String, matches broker_accounts.accounts.broker_account_id)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    portfolioAccountDelete(brokerAccountId: string, options?: RawAxiosRequestConfig): AxiosPromise<PortfolioAccountDelete200Response>;

    /**
     * Return aggregated portfolio snapshot, broker account summaries, and top holdings for the authenticated user.
     * @summary Get consolidated portfolio
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    portfolioGet(options?: RawAxiosRequestConfig): AxiosPromise<PortfolioGet200Response>;

    /**
     * Get a specific holding for the authenticated user.
     * @summary Get holding
     * @param {string} holdingId Holding identifier
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    portfolioHoldingGet(holdingId: string, options?: RawAxiosRequestConfig): AxiosPromise<HoldingResponse>;

    /**
     * Return holdings for the authenticated user with optional broker and symbol filters.
     * @summary List holdings
     * @param {string} [brokerAccountId] Filter holdings by broker account
     * @param {string} [symbol] Filter by instrument symbol
     * @param {string} [exchange] Filter by exchange
     * @param {string} [productType] Filter by product type
     * @param {boolean} [includeClosed] Include closed positions
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    portfolioHoldingsList(brokerAccountId?: string, symbol?: string, exchange?: string, productType?: string, includeClosed?: boolean, options?: RawAxiosRequestConfig): AxiosPromise<PortfolioHoldingsList200Response>;

    /**
     * Manual portfolio sync. When broker_account_id is omitted, syncs all connected broker accounts for the user. When broker_account_id is provided, syncs only that account. 
     * @summary Trigger portfolio sync
     * @param {PortfolioSyncRequest} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    portfolioSync(body: PortfolioSyncRequest, options?: RawAxiosRequestConfig): AxiosPromise<PortfolioSync200Response>;

    /**
     * Return historical sync operations for a broker account.
     * @summary Get sync history
     * @param {string} brokerAccountId Broker account identifier
     * @param {number} [limit] Maximum sync logs to return
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    portfolioSyncHistory(brokerAccountId: string, limit?: number, options?: RawAxiosRequestConfig): AxiosPromise<Array<{ [key: string]: any; }>>;

    /**
     * Return recent sync operations for a broker account.
     * @summary Get recent sync status
     * @param {string} brokerAccountId Broker account identifier
     * @param {number} [limit] Maximum sync logs to return
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    portfolioSyncStatus(brokerAccountId: string, limit?: number, options?: RawAxiosRequestConfig): AxiosPromise<Array<{ [key: string]: any; }>>;

    /**
     * Retrieve an individual transaction.
     * @summary Get transaction
     * @param {string} transactionId Transaction identifier
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    portfolioTransactionGet(transactionId: string, options?: RawAxiosRequestConfig): AxiosPromise<TransactionResponse>;

    /**
     * Return transaction history with pagination and optional filters.
     * @summary List transactions
     * @param {string} [brokerAccountId] Filter by broker account
     * @param {string} [transactionType] Filter by type (buy/sell)
     * @param {string} [symbol] 
     * @param {string} [exchange] 
     * @param {string} [fromDate] 
     * @param {string} [toDate] 
     * @param {number} [limit] 
     * @param {number} [offset] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    portfolioTransactionsList(brokerAccountId?: string, transactionType?: string, symbol?: string, exchange?: string, fromDate?: string, toDate?: string, limit?: number, offset?: number, options?: RawAxiosRequestConfig): AxiosPromise<PortfolioTransactionsList200Response>;

    /**
     * 
     * @summary Remove watchlist item by item ID
     * @param {string} groupId 
     * @param {string} itemId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    removeWatchlistItem(groupId: string, itemId: string, options?: RawAxiosRequestConfig): AxiosPromise<DeleteWatchlistGroup200Response>;

    /**
     * 
     * @summary Remove instrument from watchlist group by instrument ID
     * @param {string} userId 
     * @param {string} groupId 
     * @param {string} instrumentId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    removeWatchlistItemByInstrument(userId: string, groupId: string, instrumentId: string, options?: RawAxiosRequestConfig): AxiosPromise<DeleteWatchlistGroup200Response>;

    /**
     * 
     * @summary Set preference
     * @param {string} userId 
     * @param {string} key 
     * @param {SetUserPreferenceRequest} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    setUserPreference(userId: string, key: string, body: SetUserPreferenceRequest, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * Activate or deactivate a supported broker. Admin only.
     * @summary Update broker status
     * @param {string} brokerType 
     * @param {UpdateBrokerStatusRequest} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateBrokerStatus(brokerType: string, body: UpdateBrokerStatusRequest, options?: RawAxiosRequestConfig): AxiosPromise<BrokerMetadataResponse>;

    /**
     * 
     * @summary Update current user\'s profile
     * @param {UpdateCurrentUserProfileRequest} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateCurrentUserProfile(body: UpdateCurrentUserProfileRequest, options?: RawAxiosRequestConfig): AxiosPromise<CreateUser201Response>;

    /**
     * 
     * @summary Update user
     * @param {string} userId 
     * @param {object} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateUser(userId: string, body: object, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * Update an existing user category (admin only).
     * @summary Update user category
     * @param {string} categoryId 
     * @param {UpdateUserCategoryRequest} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateUserCategory(categoryId: string, body: UpdateUserCategoryRequest, options?: RawAxiosRequestConfig): AxiosPromise<CreateUserCategory201Response>;

    /**
     * 
     * @summary Update user profile by user ID or Firebase UID
     * @param {string} userId User ID (UUID) or Firebase UID. If Firebase UID is provided, user will be looked up first.
     * @param {UpdateCurrentUserProfileRequest} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateUserProfile(userId: string, body: UpdateCurrentUserProfileRequest, options?: RawAxiosRequestConfig): AxiosPromise<CreateUser201Response>;

    /**
     * 
     * @summary Update watchlist group
     * @param {string} groupId 
     * @param {UpdateWatchlistGroupRequest} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateWatchlistGroup(groupId: string, body: UpdateWatchlistGroupRequest, options?: RawAxiosRequestConfig): AxiosPromise<CreateWatchlistGroup201Response>;

    /**
     * 
     * @summary Update watchlist item
     * @param {string} groupId 
     * @param {string} itemId 
     * @param {UpdateWatchlistItemRequest} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateWatchlistItem(groupId: string, itemId: string, body: UpdateWatchlistItemRequest, options?: RawAxiosRequestConfig): AxiosPromise<AddWatchlistItem201Response>;

}

/**
 * DefaultApi - object-oriented interface
 */
export class DefaultApi extends BaseAPI implements DefaultApiInterface {
    /**
     * Registers a new supported broker. Admin only.
     * @summary Add a supported broker
     * @param {AddSupportedBrokerRequest} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public addSupportedBroker(body: AddSupportedBrokerRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).addSupportedBroker(body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Add instrument to watchlist group
     * @param {string} groupId 
     * @param {AddWatchlistItemRequest} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public addWatchlistItem(groupId: string, body: AddWatchlistItemRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).addWatchlistItem(groupId, body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Send AG-UI RunAgentInput request and stream AG-UI protocol events (SSE or JSON-lines format). Uses AG-UI protocol libraries for request/response handling.
     * @summary AG-UI protocol endpoint - stream agent responses
     * @param {AiAssistAguiStreamRequest} body AG-UI RunAgentInput request (from @ag-ui/core library)
     * @param {string} [accept] Response format: \&#39;text/event-stream\&#39; (SSE) or \&#39;application/x-ndjson\&#39; (JSON-lines)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public aiAssistAguiStream(body: AiAssistAguiStreamRequest, accept?: string, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).aiAssistAguiStream(body, accept, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Delete a session from Vertex AI Agent Engine. This permanently removes the session and all its associated messages.
     * @summary Delete an ADK session
     * @param {string} sessionId ADK session ID to delete
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public aiAssistSessionDelete(sessionId: string, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).aiAssistSessionDelete(sessionId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieve all messages (events) associated with a specific session from Vertex AI Agent Engine. The messages are returned in chronological order.
     * @summary Get message history for a specific ADK session
     * @param {string} sessionId ADK session ID to retrieve messages for
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public aiAssistSessionMessagesGet(sessionId: string, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).aiAssistSessionMessagesGet(sessionId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update the display name for a session. The session_id itself cannot be changed, but a custom display name can be stored and displayed in the UI.
     * @summary Update session display name
     * @param {string} sessionId ADK session ID to update
     * @param {UpdateSessionDisplayNameRequest} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public aiAssistSessionUpdate(sessionId: string, body: UpdateSessionDisplayNameRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).aiAssistSessionUpdate(sessionId, body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Create a new ADK session in Vertex AI Agent Engine. The returned session_id should be used in all subsequent AG-UI requests (via threadId field) to maintain conversation continuity across multiple user messages.
     * @summary Create ADK session for conversation continuity
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public aiAssistSessionsCreate(options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).aiAssistSessionsCreate(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieve all sessions associated with the authenticated user from Vertex AI Agent Engine. Sessions are returned as a list of session IDs that can be used for conversation continuity.
     * @summary List all ADK sessions for the authenticated user
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public aiAssistSessionsList(options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).aiAssistSessionsList(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Disconnect a broker account from the platform.
     * @summary Disconnect broker account
     * @param {BrokerAccountDisconnectRequest} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public brokerAccountDisconnect(body: BrokerAccountDisconnectRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).brokerAccountDisconnect(body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieve a single broker account.
     * @summary Get broker account
     * @param {string} accountId Broker account identifier
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public brokerAccountGet(accountId: string, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).brokerAccountGet(accountId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update broker account preferences.
     * @summary Update broker account
     * @param {string} accountId Broker account identifier
     * @param {BrokerAccountUpdateRequest} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public brokerAccountUpdate(accountId: string, body: BrokerAccountUpdateRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).brokerAccountUpdate(accountId, body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * List broker accounts linked to the authenticated user.
     * @summary List broker accounts
     * @param {string} [brokerType] Filter by broker type
     * @param {string} [status] Filter by account status
     * @param {boolean} [paperTrading] Filter by paper trading mode
     * @param {number} [limit] Maximum number of results
     * @param {number} [offset] Pagination offset
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public brokerAccountsList(brokerType?: string, status?: string, paperTrading?: boolean, limit?: number, offset?: number, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).brokerAccountsList(brokerType, status, paperTrading, limit, offset, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get list of all supported broker platforms. Public endpoint - no authentication required.
     * @summary Get supported brokers
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public brokerAccountsSupportedBrokers(options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).brokerAccountsSupportedBrokers(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Initiate broker account registration and OAuth flow.
     * @summary Register broker account
     * @param {BrokerRegistrationRequest} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public brokerRegistration(body: BrokerRegistrationRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).brokerRegistration(body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Handle OAuth callbacks from broker partners. Public endpoint invoked by brokers.
     * @summary Broker OAuth callback
     * @param {string} brokerType Broker identifier
     * @param {string} [state] 
     * @param {string} [oauthState] 
     * @param {string} [code] 
     * @param {string} [requestToken] 
     * @param {string} [action] 
     * @param {string} [status] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public brokerRegistrationCallback(brokerType: string, state?: string, oauthState?: string, code?: string, requestToken?: string, action?: string, status?: string, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).brokerRegistrationCallback(brokerType, state, oauthState, code, requestToken, action, status, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Deregister and delete a broker account by registration ID.
     * @summary Deregister broker account
     * @param {string} registrationId Registration identifier
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public brokerRegistrationDeregister(registrationId: string, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).brokerRegistrationDeregister(registrationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Migrate existing OAuth account to TOTP-based automated authentication. Verifies account ownership and current auth_mode=\'oauth\', validates TOTP secret format, stores credentials in Secret Manager, performs one-time validation login, and updates account to TOTP mode if successful. Existing access token is preserved during migration.
     * @summary Migrate existing OAuth account to TOTP-based automated authentication
     * @param {string} registrationId Registration identifier
     * @param {BrokerRegistrationMigrateToTOTPRequest} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public brokerRegistrationMigrateToTOTP(registrationId: string, body: BrokerRegistrationMigrateToTOTPRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).brokerRegistrationMigrateToTOTP(registrationId, body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Reconnect broker account. Routes to automated TOTP login or OAuth flow based on account auth_mode. If auth_mode=\'totp_automated\', performs automated login using stored TOTP credentials. If auth_mode=\'oauth\', returns OAuth URL for manual login.
     * @summary Reconnect broker account
     * @param {BrokerRegistrationReconnectRequest} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public brokerRegistrationReconnect(body: BrokerRegistrationReconnectRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).brokerRegistrationReconnect(body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Check the status of a broker registration flow.
     * @summary Get registration status
     * @param {string} registrationId Registration identifier
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public brokerRegistrationStatus(registrationId: string, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).brokerRegistrationStatus(registrationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Register broker account with TOTP credentials for automated authentication. Supports any broker that implements automated login (e.g., Zerodha, Groww). Stores credentials securely in GCP Secret Manager, creates account record, performs one-time validation login, and returns registration details if successful. If validation fails, credentials are automatically cleaned up.
     * @summary Register broker account with TOTP credentials
     * @param {BrokerRegistrationTOTPRequest} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public brokerRegistrationTOTP(body: BrokerRegistrationTOTPRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).brokerRegistrationTOTP(body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update TOTP credentials for an existing account. Verifies account ownership, validates new credentials format, updates credentials in Secret Manager, performs validation login with new credentials, and updates account metadata if successful. Requires account to be in TOTP mode (auth_mode=\'totp_automated\').
     * @summary Update TOTP credentials for existing account
     * @param {string} registrationId Registration identifier
     * @param {BrokerRegistrationUpdateTOTPCredentialsRequest} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public brokerRegistrationUpdateTOTPCredentials(registrationId: string, body: BrokerRegistrationUpdateTOTPCredentialsRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).brokerRegistrationUpdateTOTPCredentials(registrationId, body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Updates a user\'s role. Caller must have the \'admin\' role — enforced server-side.
     * @summary Change user role (admin only)
     * @param {string} userId Target user\&#39;s UUID
     * @param {ChangeUserRoleRequest} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public changeUserRole(userId: string, body: ChangeUserRoleRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).changeUserRole(userId, body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Check quota for resource type
     * @param {string} userId 
     * @param {CheckUserQuotaResourceTypeEnum} resourceType 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public checkUserQuota(userId: string, resourceType: CheckUserQuotaResourceTypeEnum, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).checkUserQuota(userId, resourceType, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create user
     * @param {CreateUserRequest} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public createUser(body: CreateUserRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).createUser(body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Create a new user category (admin only).
     * @summary Create user category
     * @param {CreateUserCategoryRequest} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public createUserCategory(body: CreateUserCategoryRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).createUserCategory(body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create watchlist group
     * @param {CreateWatchlistGroupRequest} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public createWatchlistGroup(body: CreateWatchlistGroupRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).createWatchlistGroup(body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete user (soft delete)
     * @param {string} userId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public deleteUser(userId: string, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).deleteUser(userId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete watchlist group
     * @param {string} groupId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public deleteWatchlistGroup(groupId: string, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).deleteWatchlistGroup(groupId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Detailed health check
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public detailedHealthCheck(options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).detailedHealthCheck(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get all watchlist groups
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getAllWatchlistGroups(options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getAllWatchlistGroups(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get all watchlist items in group
     * @param {string} groupId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getAllWatchlistItems(groupId: string, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getAllWatchlistItems(groupId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get current user
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getCurrentUser(options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getCurrentUser(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get current user\'s profile
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getCurrentUserProfile(options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getCurrentUserProfile(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieve the instruments that make up a specific index.
     * @summary Get index constituents
     * @param {string} indexSymbol Index symbol (e.g., NIFTY 50)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getIndexConstituents(indexSymbol: string, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getIndexConstituents(indexSymbol, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieve a list of all available market indices.
     * @summary Get all indices
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getIndices(options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getIndices(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get user by ID
     * @param {string} userId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getUserById(userId: string, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getUserById(userId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * List all user categories (admin only). Reference data.
     * @summary List user categories
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getUserCategories(options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getUserCategories(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get preference by key
     * @param {string} userId 
     * @param {string} key 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getUserPreference(userId: string, key: string, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getUserPreference(userId, key, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get all user preferences
     * @param {string} userId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getUserPreferences(userId: string, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getUserPreferences(userId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get user profile by user ID or Firebase UID
     * @param {string} userId User ID (UUID) or Firebase UID. If Firebase UID is provided, user will be looked up first.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getUserProfile(userId: string, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getUserProfile(userId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get user quotas
     * @param {string} userId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getUserQuotas(userId: string, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getUserQuotas(userId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get watchlist group
     * @param {string} groupId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getWatchlistGroup(groupId: string, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getWatchlistGroup(groupId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get watchlist item
     * @param {string} groupId 
     * @param {string} itemId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getWatchlistItem(groupId: string, itemId: string, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getWatchlistItem(groupId, itemId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Basic health check
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public healthCheck(options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).healthCheck(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Fetch multiple instruments by ID in a single request.
     * @summary Batch fetch instruments
     * @param {InstrumentBatchRequest} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public instrumentBatch(body: InstrumentBatchRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).instrumentBatch(body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieve futures instruments for a symbol.
     * @summary Get futures instruments
     * @param {string} symbol 
     * @param {string} [exchange] Exchange (default: NFO). Optional.
     * @param {string} [expiryStart] Start of expiry date range (YYYY-MM-DD)
     * @param {string} [expiryEnd] End of expiry date range (YYYY-MM-DD)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public instrumentFutures(symbol: string, exchange?: string, expiryStart?: string, expiryEnd?: string, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).instrumentFutures(symbol, exchange, expiryStart, expiryEnd, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Fetch instrument master data by instrument identifier.
     * @summary Get instrument
     * @param {string} instrumentId Instrument identifier
     * @param {boolean} [includeMappings] Whether to include broker mappings in the response
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public instrumentGet(instrumentId: string, includeMappings?: boolean, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).instrumentGet(instrumentId, includeMappings, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get broker-specific instrument token from symbol and broker type. Reverse operation of token resolution. Used when user selects an instrument symbol and needs the broker-specific token for their broker account.
     * @summary Get broker token by symbol
     * @param {string} symbol Trading symbol (e.g., \&#39;INFY\&#39;)
     * @param {string} broker Broker type (zerodha, upstox, dhan, etc.)
     * @param {string} [exchange] Exchange code (e.g., \&#39;NSE\&#39;, \&#39;BSE\&#39;). Optional, searches all if not provided.
     * @param {string} [expiryDate] Expiry date for derivatives (YYYY-MM-DD)
     * @param {number} [strikePrice] Strike price for options
     * @param {InstrumentGetTokenBySymbolOptionTypeEnum} [optionType] Option type (CE/PE) for options
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public instrumentGetTokenBySymbol(symbol: string, broker: string, exchange?: string, expiryDate?: string, strikePrice?: number, optionType?: InstrumentGetTokenBySymbolOptionTypeEnum, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).instrumentGetTokenBySymbol(symbol, broker, exchange, expiryDate, strikePrice, optionType, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieve options chain data for a symbol.
     * @summary Get options chain
     * @param {string} symbol 
     * @param {string} expiryDate Expiry date (YYYY-MM-DD)
     * @param {string} [exchange] Exchange (default: NFO). Optional.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public instrumentOptionsChain(symbol: string, expiryDate: string, exchange?: string, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).instrumentOptionsChain(symbol, expiryDate, exchange, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Search instruments by keyword with exchange filters. When include_mappings=true, each instrument includes broker_mappings (which brokers have this instrument). Default false for performance; use true only in admin/reference UIs.
     * @summary Search instruments
     * @param {string} query Search keyword
     * @param {string} [exchange] Optional exchange filter
     * @param {string} [segment] Optional segment filter
     * @param {string} [sector] Optional sector filter
     * @param {string} [instrumentType] Optional instrument type filter
     * @param {boolean} [isActive] Filter by active status
     * @param {number} [limit] Maximum search results
     * @param {number} [offset] Pagination offset
     * @param {boolean} [includeMappings] Include broker_mappings per instrument (which brokers have it). Use only in admin/reference UIs; keep false for instrument sidebar for performance.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public instrumentSearch(query: string, exchange?: string, segment?: string, sector?: string, instrumentType?: string, isActive?: boolean, limit?: number, offset?: number, includeMappings?: boolean, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).instrumentSearch(query, exchange, segment, sector, instrumentType, isActive, limit, offset, includeMappings, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Resolve a broker-specific token or symbol to a platform instrument.
     * @summary Resolve broker token
     * @param {string} broker Broker identifier
     * @param {string} token Broker token/symbol
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public instrumentTokenResolve(broker: string, token: string, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).instrumentTokenResolve(broker, token, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Resolve multiple broker tokens to platform instruments.
     * @summary Batch resolve broker tokens
     * @param {InstrumentTokenResolveBatchRequest} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public instrumentTokenResolveBatch(body: InstrumentTokenResolveBatchRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).instrumentTokenResolveBatch(body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary List users
     * @param {number} [page] 
     * @param {number} [size] 
     * @param {string} [email] Filter by email (partial match)
     * @param {ListUsersStatusEnum} [status] 
     * @param {ListUsersRoleEnum} [role] Filter by role
     * @param {boolean} [isActive] Filter by active status
     * @param {string} [categoryId] Filter by category ID
     * @param {string} [sortBy] 
     * @param {ListUsersSortOrderEnum} [sortOrder] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public listUsers(page?: number, size?: number, email?: string, status?: ListUsersStatusEnum, role?: ListUsersRoleEnum, isActive?: boolean, categoryId?: string, sortBy?: string, sortOrder?: ListUsersSortOrderEnum, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).listUsers(page, size, email, status, role, isActive, categoryId, sortBy, sortOrder, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Place multiple orders simultaneously with concurrency control. Supports SIMPLE orders only (market, limit, stop, stop_limit).
     * @summary Place batch orders
     * @param {OrdersBatchRequest} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public ordersBatch(body: OrdersBatchRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).ordersBatch(body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Cancel an existing order and return its final state.
     * @summary Cancel order
     * @param {string} platformOrderId Platform order identifier
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public ordersCancel(platformOrderId: string, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).ordersCancel(platformOrderId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Create a new order and place it with the configured broker. Supports market, limit, stop, trailing stop, iceberg and multi-leg strategies.
     * @summary Create order
     * @param {OrdersCreateRequest} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public ordersCreate(body: OrdersCreateRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).ordersCreate(body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Fetch a single order with broker sync details and fills.
     * @summary Get order
     * @param {string} platformOrderId Platform order identifier
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public ordersGet(platformOrderId: string, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).ordersGet(platformOrderId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * List orders for the authenticated user with filtering and pagination.
     * @summary List orders
     * @param {string} [status] Filter by order status
     * @param {string} [instrumentId] Filter by instrument identifier
     * @param {number} [limit] Number of records to return
     * @param {number} [offset] Pagination offset
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public ordersList(status?: string, instrumentId?: string, limit?: number, offset?: number, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).ordersList(status, instrumentId, limit, offset, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Modify an existing order. Only orders in PENDING or PLACED status can be modified. Only certain fields can be updated (quantity, price, stop_price, limit_price, notes).
     * @summary Modify order
     * @param {string} platformOrderId Platform order identifier
     * @param {OrdersModifyRequest} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public ordersModify(platformOrderId: string, body: OrdersModifyRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).ordersModify(platformOrderId, body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Manually trigger synchronization of order details from broker and update the broker_orders table.
     * @summary Sync order from broker
     * @param {string} platformOrderId Platform order identifier
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public ordersSync(platformOrderId: string, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).ordersSync(platformOrderId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get chronological timeline of all events for an order, combining data from platform_orders, order_status_log, order_fills, and broker_orders.
     * @summary Get order timeline
     * @param {string} platformOrderId Platform order identifier
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public ordersTimeline(platformOrderId: string, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).ordersTimeline(platformOrderId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Delete all portfolio data (holdings and transactions) for a broker account. This endpoint is called automatically when a broker account is deregistered/deleted. It removes all associated portfolio data including holdings and transactions. **Security**: Deletion requires BOTH firebase_uid (from authenticated user) AND broker_account_id to match, ensuring data belongs to the user before deletion.
     * @summary Delete portfolio data for broker account
     * @param {string} brokerAccountId Broker account identifier (String, matches broker_accounts.accounts.broker_account_id)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public portfolioAccountDelete(brokerAccountId: string, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).portfolioAccountDelete(brokerAccountId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Return aggregated portfolio snapshot, broker account summaries, and top holdings for the authenticated user.
     * @summary Get consolidated portfolio
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public portfolioGet(options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).portfolioGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get a specific holding for the authenticated user.
     * @summary Get holding
     * @param {string} holdingId Holding identifier
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public portfolioHoldingGet(holdingId: string, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).portfolioHoldingGet(holdingId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Return holdings for the authenticated user with optional broker and symbol filters.
     * @summary List holdings
     * @param {string} [brokerAccountId] Filter holdings by broker account
     * @param {string} [symbol] Filter by instrument symbol
     * @param {string} [exchange] Filter by exchange
     * @param {string} [productType] Filter by product type
     * @param {boolean} [includeClosed] Include closed positions
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public portfolioHoldingsList(brokerAccountId?: string, symbol?: string, exchange?: string, productType?: string, includeClosed?: boolean, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).portfolioHoldingsList(brokerAccountId, symbol, exchange, productType, includeClosed, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Manual portfolio sync. When broker_account_id is omitted, syncs all connected broker accounts for the user. When broker_account_id is provided, syncs only that account. 
     * @summary Trigger portfolio sync
     * @param {PortfolioSyncRequest} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public portfolioSync(body: PortfolioSyncRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).portfolioSync(body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Return historical sync operations for a broker account.
     * @summary Get sync history
     * @param {string} brokerAccountId Broker account identifier
     * @param {number} [limit] Maximum sync logs to return
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public portfolioSyncHistory(brokerAccountId: string, limit?: number, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).portfolioSyncHistory(brokerAccountId, limit, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Return recent sync operations for a broker account.
     * @summary Get recent sync status
     * @param {string} brokerAccountId Broker account identifier
     * @param {number} [limit] Maximum sync logs to return
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public portfolioSyncStatus(brokerAccountId: string, limit?: number, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).portfolioSyncStatus(brokerAccountId, limit, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieve an individual transaction.
     * @summary Get transaction
     * @param {string} transactionId Transaction identifier
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public portfolioTransactionGet(transactionId: string, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).portfolioTransactionGet(transactionId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Return transaction history with pagination and optional filters.
     * @summary List transactions
     * @param {string} [brokerAccountId] Filter by broker account
     * @param {string} [transactionType] Filter by type (buy/sell)
     * @param {string} [symbol] 
     * @param {string} [exchange] 
     * @param {string} [fromDate] 
     * @param {string} [toDate] 
     * @param {number} [limit] 
     * @param {number} [offset] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public portfolioTransactionsList(brokerAccountId?: string, transactionType?: string, symbol?: string, exchange?: string, fromDate?: string, toDate?: string, limit?: number, offset?: number, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).portfolioTransactionsList(brokerAccountId, transactionType, symbol, exchange, fromDate, toDate, limit, offset, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Remove watchlist item by item ID
     * @param {string} groupId 
     * @param {string} itemId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public removeWatchlistItem(groupId: string, itemId: string, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).removeWatchlistItem(groupId, itemId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Remove instrument from watchlist group by instrument ID
     * @param {string} userId 
     * @param {string} groupId 
     * @param {string} instrumentId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public removeWatchlistItemByInstrument(userId: string, groupId: string, instrumentId: string, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).removeWatchlistItemByInstrument(userId, groupId, instrumentId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Set preference
     * @param {string} userId 
     * @param {string} key 
     * @param {SetUserPreferenceRequest} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public setUserPreference(userId: string, key: string, body: SetUserPreferenceRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).setUserPreference(userId, key, body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Activate or deactivate a supported broker. Admin only.
     * @summary Update broker status
     * @param {string} brokerType 
     * @param {UpdateBrokerStatusRequest} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public updateBrokerStatus(brokerType: string, body: UpdateBrokerStatusRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).updateBrokerStatus(brokerType, body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update current user\'s profile
     * @param {UpdateCurrentUserProfileRequest} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public updateCurrentUserProfile(body: UpdateCurrentUserProfileRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).updateCurrentUserProfile(body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update user
     * @param {string} userId 
     * @param {object} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public updateUser(userId: string, body: object, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).updateUser(userId, body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update an existing user category (admin only).
     * @summary Update user category
     * @param {string} categoryId 
     * @param {UpdateUserCategoryRequest} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public updateUserCategory(categoryId: string, body: UpdateUserCategoryRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).updateUserCategory(categoryId, body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update user profile by user ID or Firebase UID
     * @param {string} userId User ID (UUID) or Firebase UID. If Firebase UID is provided, user will be looked up first.
     * @param {UpdateCurrentUserProfileRequest} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public updateUserProfile(userId: string, body: UpdateCurrentUserProfileRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).updateUserProfile(userId, body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update watchlist group
     * @param {string} groupId 
     * @param {UpdateWatchlistGroupRequest} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public updateWatchlistGroup(groupId: string, body: UpdateWatchlistGroupRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).updateWatchlistGroup(groupId, body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update watchlist item
     * @param {string} groupId 
     * @param {string} itemId 
     * @param {UpdateWatchlistItemRequest} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public updateWatchlistItem(groupId: string, itemId: string, body: UpdateWatchlistItemRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).updateWatchlistItem(groupId, itemId, body, options).then((request) => request(this.axios, this.basePath));
    }
}

export const CheckUserQuotaResourceTypeEnum = {
    Strategy: 'strategy',
    Screener: 'screener'
} as const;
export type CheckUserQuotaResourceTypeEnum = typeof CheckUserQuotaResourceTypeEnum[keyof typeof CheckUserQuotaResourceTypeEnum];
export const InstrumentGetTokenBySymbolOptionTypeEnum = {
    Ce: 'CE',
    Pe: 'PE'
} as const;
export type InstrumentGetTokenBySymbolOptionTypeEnum = typeof InstrumentGetTokenBySymbolOptionTypeEnum[keyof typeof InstrumentGetTokenBySymbolOptionTypeEnum];
export const ListUsersStatusEnum = {
    Active: 'active',
    Inactive: 'inactive',
    Suspended: 'suspended',
    Deleted: 'deleted'
} as const;
export type ListUsersStatusEnum = typeof ListUsersStatusEnum[keyof typeof ListUsersStatusEnum];
export const ListUsersRoleEnum = {
    User: 'user',
    Admin: 'admin'
} as const;
export type ListUsersRoleEnum = typeof ListUsersRoleEnum[keyof typeof ListUsersRoleEnum];
export const ListUsersSortOrderEnum = {
    Asc: 'asc',
    Desc: 'desc'
} as const;
export type ListUsersSortOrderEnum = typeof ListUsersSortOrderEnum[keyof typeof ListUsersSortOrderEnum];


